/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').
    controller('WebSiteCtrl',["$log","$scope","$location","$http","$timeout","$window","$anchorScroll","$sce","$dialog","$filter","$route","$routeParams","Loader","Auth","HumanResourceData","PhysicalResourceData",
        "CategoryData","SiteData","CategoryView","HumanResourceView","PhysicalResourceView","SiteView","WebPreLoaderData","CustomerSrv","CustomerData","CustomerView",
        "CompanyImageData","ImageData","AppData","AppSrv","App","AppAttribute","$spMenu","SaleView","BookingView","CompanyImageSrv","ServiceView","VatData","VatView",
        "ProductCategoryView","ProductCategoryData","CureCategoryView","CureCategoryData","LoyaltyCardCategoryView","LoyaltyCardCategoryData","ProductView","CureView","LoyaltyCardView",
        "AvailableTableView","bugsnag","DaySrv","DateSrv","WidgetView","MobileDeviceSrv","LanguageManager","gettextCatalog","PhoneFormat","CurrencyManager","CustomerPostSrv","Countries",
        "MonitoringSrv","MonitoringHealthState","MonitoringApplication","CureItemSrv","CureItemData","moment","MeasureStore","TimeMeasures","Constants","BasicAuthRole",
        "WebSiteSpecifications","AppCode","Brand","OfferManager", "Images", "StoreAppCode",
        function ($log,$scope,$location,$http,$timeout,$window,$anchorScroll,$sce,$dialog,$filter,$route,$routeParams,Loader,Auth,HumanResourceData,PhysicalResourceData,
                  CategoryData,SiteData,CategoryView,HumanResourceView,PhysicalResourceView,SiteView,WebPreLoaderData,CustomerSrv,CustomerData,CustomerView,
                  CompanyImageData,ImageData,AppData,AppSrv,App,AppAttribute,$spMenu,SaleView,BookingView,CompanyImageSrv,ServiceView,VatData,VatView,
                  ProductCategoryView,ProductCategoryData,CureCategoryView,CureCategoryData,LoyaltyCardCategoryView,LoyaltyCardCategoryData,ProductView,CureView,LoyaltyCardView,
                  AvailableTableView,bugsnag,DaySrv,DateSrv,WidgetView,MobileDeviceSrv,LanguageManager,gettextCatalog,PhoneFormat,CurrencyManager,CustomerPostSrv,Countries,
                  MonitoringSrv,MonitoringHealthState,MonitoringApplication,CureItemSrv,CureItemData,moment,MeasureStore,TimeMeasures,Constants,BasicAuthRole,
                  WebSiteSpecifications,AppCode,Brand,OfferManager, Images, StoreAppCode) {

            console.time('globalLoading');

            if("migration" === WebPreLoaderData.type && WebPreLoaderData.marketplaceUrl) {
                location.replace(WebPreLoaderData.marketplaceUrl);
            }



            MeasureStore.registerStart(TimeMeasures.MODEL_GLOBAL_TIME);

            gettextCatalog.debug = false;


            var bienvenue = gettextCatalog.getString("Bienvenue chez...");
            let tempUser = Auth.getCurrentUser();
            if (!tempUser){
                const absUrl = $location.absUrl();
                const splitUrl = absUrl.split('/')
                tempUser = {token: splitUrl.pop()}
            }
            $scope.ad = {
                currentUser: tempUser,
                view: {
                    bookingStatusImage: Images.saleStatus,
                    domainView: $scope,
                    vatsView: [],
                    categoryRootView: null,
                    productCategoryRootView: null,
                    cureCategoryRootView: null,
                    loyaltyCardCategoryRootView: null,
                    customerView: null,
                    currentCategoryView: null,
                    currentProductCategoryView: null,
                    currentCureCategoryView: null,
                    currentLoyaltyCardCategoryView: null,
                    cureDisplayError: false,
                    currentServiceView: null,
                    currentProductView: null,
                    currentCureView: null,
                    currentLoyaltyCardView: null,
                    gTemplates: [],
                    giftItemTypeSelected: "",
                    giftItemMailImage: { urlPreview: "/img/exemplebon_mail.svg" },
                    giftItemDeliveryImage: { urlPreview: "/img/exemplebon_box.svg" },
                    giftItemPrintableImage: { urlPreview: "/img/exemplebon_print.svg" },
                    templates: [],
                    humanResourcesView: [],
                    physicalResourcesView: [],
                    currentBookingView: null,
                    bookedBookingView: null,//booked
                    currentSaleView: null,
                    soldSaleView: null,
                    homeItemsView: [],
                    homeWidgetView: null,
                    defaultWidgetView: null,
                    homeGridWidgetsView: null,
                    imagesServiceView: [],
                    flexyFilteredImagesView:[],
                    imagesCompanyView: [],
                    imagesNoCustomer : [],
                    imagesBgCompanyView: [],
                    imagesGiftView: [],
                    currentGiftItemImage: null,
                    dialogWebSiteEditorCtrl: {
                        subTab: 1
                    },
                    imagesAboutCompanyView: [],
                    aTableView: null,//table of availabilities
                    errorMessage: null,// by example return by server when saving
                    currentBookingServiceView: null,
                    currentParentCategoriesViewTree: [],
                    siteView: null,
                    servicesViewIndex: [],//Keep index
                    productsViewIndex: [],
                    curesViewIndex: [],
                    searchedText: "",
                    mobileHeaderCartVisible: false, //Manage display on mobile view of menu/cart
                    mobileHeaderAccountVisible: false, //Manage display on mobile view of menu/account
                    mobileHeaderSearchVisible: false,
                    imagesBgTransparentView: [],
                    imagesBgOpaqueView: [],
                    adminEditPanelTab: 0,
                    adminEditPanelDesignTab: 0,
                    adminEditPanelDesignBgTab: 1,
                    adminEditPanelDesignCreate: false,
                    adminEditPanelPageTab: 0,
                    adminEditPanelPageServiceTab: 1,
                    adminEditPanelPageGiftTab: 1,
                    logoImageUrl: null,//url to logo image
                    homeTextEditPanel: false,
                    logoEditPanel: false,
                    logoEditPanelTab: 1,
                    logoEditPanelFlowConfig: {
                        target: '/rest/companyImageUpload',
                        method: 'octet',
                        query: {companyCode: WebPreLoaderData.companyCode, type: 'logo'},
                        maxChunkRetries: 1,
                        chunkRetryInterval: 10000,
                        chunkSize: 1024 * 1024 * 5,
                        simultaneousUploads: 1,
                        singleFile: true,
                        testChunks: false,
                        headers: {Authorization: tempUser.token}
                    },
                    globalBgFlowConfig: {
                        target: '/rest/companyImageUpload',
                        method: 'octet',
                        query: {companyCode: WebPreLoaderData.companyCode, type: 'background'},
                        maxChunkRetries: 1,
                        chunkRetryInterval: 10000,
                        chunkSize: 1024 * 1024 * 5,
                        simultaneousUploads: 1,
                        singleFile: true,
                        testChunks: false,
                        headers: {Authorization: tempUser.token}
                    },
                    aboutFlowConfig: {
                        target: '/rest/companyImageUpload',
                        method: 'octet',
                        query: {companyCode: WebPreLoaderData.companyCode, type: 'about'},
                        maxChunkRetries: 1,
                        chunkRetryInterval: 10000,
                        chunkSize: 1024 * 1024 * 5,
                        simultaneousUploads: 1,
                        singleFile: true,
                        testChunks: false,
                        headers: {Authorization: tempUser.token}
                    },
                    giftItemsFlowConfig: {
                        target: '/rest/companyImageUpload',
                        method: 'octet',
                        query: {companyCode: WebPreLoaderData.companyCode, type: 'giftItem'},
                        maxChunkRetries: 1,
                        chunkRetryInterval: 10000,
                        chunkSize: 1024 * 1024 * 5,
                        simultaneousUploads: 1,
                        singleFile: true,
                        testChunks: false,
                        headers: {Authorization: tempUser.token}
                    },
                    menuEditPanel: false,
                    loaded: false,
                    isOnMobile: false,
                    showMenuMobile: false,
                    gridOptions: {
                        cellHeight: 'auto',
                        verticalMargin: 15,
                        disableResize: true,
                        disableDrag: true,
                        auto: false,
                        float: false
                    },
                    specialMenuVisible: false,
                    fontOptions: [
                        { name: 'Abril', css: "'Abril Fatface', cursive", size: 100, padding_top: 0 },
                        { name: 'Arial', css: "Arial, Helvetica, sans-serif", size: 100, padding_top: 0 },
                        { name: 'Arvo', css: "'Arvo', serif", size: 90, padding_top: 0 },
                        { name: 'Comic Sans MS', css: "'comic sans ms', sans-serif", size: 95, padding_top: 0 },
                        { name: 'Damion', css: "'Damion', cursive", size: 120, padding_top: 0 },
                        { name: 'Droid Sans', css: "'Droid Sans', sans-serif", size: 100, padding_top: 0 },
                        { name: 'Parisienne', css: "'Parisienne', cursive", size: 115, padding_top: 2 },
                        { name: 'Georgia', css: 'georgia, serif', size: 100, padding_top: 0 },
                        { name: 'IM Fell French', css: "'IM Fell French Canon', serif", size: 100, padding_top: 0 },
                        { name: 'Josefin', css: "'Josefin Slab', serif", size: 110, padding_top: 3 },
                        { name: 'Lato', css: 'Lato, sans-serif', size: 100, padding_top: 0 },
                        { name: 'Lucida Su', css: '"Lucida Sans Unicode", "Lucida Grande", sans-serif', size: 95, padding_top: 0 },
                        { name: 'Open Sans', css: "'Open Sans', sans-serif", size: 95, padding_top: 0 },
                        { name: 'Old Standard', css: "'Old Standard TT', serif", size: 100, padding_top: 0 },
                        { name: 'Palatino', css: "'Palatino Linotype', 'Book Antiqua', Palatino, serif", size: 100, padding_top: 2 },
                        { name: 'Playball', css: "'Playball', cursive ", size: 120, padding_top: 2 },
                        { name: 'Pinyon Script', css: "'Pinyon Script', cursive;line-height: 1.35", size: 120, padding_top: 3 },
                        { name: 'Times New Roman', css: "'Times New Roman', Times, serif", size: 105, padding_top: 0 },
                        { name: 'Trebuchet MS', css: "'trebuchet ms', sans-serif", size: 100, padding_top: 0 },
                        { name: 'Petit Formal S', css: "'Petit Formal Script', cursive", size: 90, padding_top: 2 },
                        { name: 'PT Sans', css: "'PT Sans', sans-serif", size: 100, padding_top: 0 },
                        { name: 'PT Serif', css: "'PT Serif', serif", size: 100, padding_top: 0 },
                        { name: 'Tahoma', css: 'Tahoma, Geneva, sans-serif', size: 100, padding_top: 0 },
                        { name: 'Tangerine', css: "'Tangerine', cursive;line-height: 0.9", size: 180, padding_top: 4 },
                        { name: 'Verdana', css: 'Verdana, Geneva, sans-serif', size: 90, padding_top: 0 },
                        { name: 'Vollkorn', css: "'Vollkorn', serif", size: 100, padding_top: 0 }
                    ],
                    bithDateOptions: {
                        startingDay: 1,
                        showWeeks: false,
                        datepickerMode: 'year',
                        yearRange: 20,
                        language: 'fr',
                        format: 'dd/MM/yyyy'
                    }
                },
                appAttributes: {
                    homeDisplayType: "manual",//creative /  manual / default
                    homeLabel: gettextCatalog.getString("Accueil"),
                    displayAbout: false,
                    aboutLabel: gettextCatalog.getString("Concept"),
                    displayContact: false,
                    contactLabel: gettextCatalog.getString("Contact"),
                    displayServices: true,
                    servicesLabel: gettextCatalog.getString("Prestations"),
                    servicesProductsLabel: gettextCatalog.getString("Découvrez nos produits de qualité utilisés pour cette prestation"),
                    servicesCuresLabel:  gettextCatalog.getString("Découvrez nos forfaits qui proposent cette prestation"),
                    displayProducts: false,
                    productsLabel: gettextCatalog.getString("Produits"),
                    displayCures: false,
                    curesLabel: gettextCatalog.getString("Cures"),
                    displayLoyaltyCards: false,
                    loyaltyCardsLabel: gettextCatalog.getString("Fidélité"),
                    displayCustomerPost: false,
                    customerPostLabel: gettextCatalog.getString("Avis"),
                    autoValidateCustomerPost : false,
                    welcomePictureCustomerPost : true,
                    giftsLabel: gettextCatalog.getString("Chèque cadeau"),
                    giftItemMailImageId: "",
                    giftItemDeliveryImageId: "",
                    giftItemPrintableImageId: "",
                    headerType: gettextCatalog.getString("default"),
                    homeAbout: false,
                    homeAboutSentence: gettextCatalog.getString("Découvrez notre salon"),
                    homeOffer: true,
                    homeOfferSentence: gettextCatalog.getString("Profitez de nos meilleures offres"),
                    homeService: true,
                    homeServiceSentence: gettextCatalog.getString("Réservez ou offrez des prestations"),
                    homeCure: false,
                    homeCureSentence: gettextCatalog.getString("Achetez des cures"),
                    homeProduct: false,
                    homeProductSentence: gettextCatalog.getString("Achetez des produits"),
                    homeGiftItem: true,
                    homeGiftItemSentence: gettextCatalog.getString("Offrez un chèque cadeau"),
                    homeLoyaltyCard: false,
                    homeLoyaltyCardSentence: gettextCatalog.getString("Prenez une carte de fidélité"),
                    footerTime: true,
                    footerAddress: true,
                    footerMap: true,
                    footerSocial: true,
                    footerFacebook: null,
                    footerTwitter: null,
                    footerInstagram: null,
                    footerPinterest: null,
                    displayFacebook: false,
                    facebookLabel: "",
                    onlineBooking: false,
                    allowChooseHr: false,
                    allowBookingComment: false,//payment
                    bookingCommentSentence: null,
                    hasBookingPayment: true,
                    hasBookingPaymentAdvance: false,
                    bookingPaymentAdvancePercent: 10,
                    hasBookingPaymentMandatory: true,
                    hasBookingPaymentOnAmount: false,
                    bookingPaymentOnAmount: 100,
                    nbBookingWeeks: 12,
                    nbBookingBeforeTime: 0,
                    triesTime: 15,
                    autoFilling: true,
                    hasCurePayment: true,
                    hasProductPayment: true,
                    hasProductDelivery: true,
                    hasProductDeliveryCharge: true,
                    productDeliverySentence:  gettextCatalog.getString("Vous recevrez vos produits dans un délai de 2 à 4 jours via Chronopost."),
                    productDeliveryCharge: 5,
                    hasLoyaltyCardPayment: true,
                    hasGiftItem: false,
                    hasServiceGift: false,
                    hasGiftItemDelivery: true,
                    giftItemDeliverySentence:  gettextCatalog.getString("Vous recevrez votre bon cadeau dans un délai d'une semaine et vous pourrez l'offrir à la personne de votre choix."),
                    hasGiftItemDeliveryCharge: false,
                    giftItemDeliveryCharge: 5,
                    hasGiftItemMail: true,
                    minimalPlanningFilling: false,
                    giftMonthValidity: 12,
                    globalBgImageType: null,
                    globalBgImage: "",
                    globalBgImageSlides: [],
                    globalBgImageUseSlide: false,
                    globalBgImageOverlay: true,
                    globalBgColor: "",
                    footerBgColor: null,
                    footerFontColor: null,
                    globalObjectColor: null,
                    globalObjectColorInserted: false,
                    globalFontColor: "",
                    globalFontFamilyInserted: false,
                    globalFontFamily: null,
                    logoFontColor: null,
                    logoShadowColor: null,
                    logoText: null,
                    logoImageId: null,
                    titleHomeLabel:  gettextCatalog.getString("Carte des soins"),
                    titleIsDisplayed: true,
                    titleBgColorStart: "",
                    titleBgColorEnd: "",
                    titleFontColor: "",
                    menuIsDisplayed: true,
                    menuBgColorStart: "",
                    menuBgColorEnd: "",
                    menuFontColor: "",
                    menuShadowColor: null,
                    homeTextHtml: "<h2>"+bienvenue+"</h2><p>Votre description ...</p>",
                    googleAnalyticsId: null,
                    javascriptOnHeader: null,
                    javascriptOnBody: null,
                    cgvHtml: null,
                    isBurgerOpen : false
                },
                subscriptionsStatus: {},
                activeOfferCode: WebPreLoaderData.activeOfferCode,
                startDate: null,
                dataLoaded: false,
                customerConnected: false,
                companyCode: WebPreLoaderData.companyCode,
                localeCode: WebPreLoaderData.localeCode === "null" ? null : WebPreLoaderData.localeCode,
                companyCountry: WebPreLoaderData.companyCountry,
                currencyCode: WebPreLoaderData.currencyCode === "null" ? null : WebPreLoaderData.currencyCode,
                currencySymbol: WebPreLoaderData.currencySymbol === "null" ? null : WebPreLoaderData.currencySymbol,
                currencyCodeIso: WebPreLoaderData.currencyCodeIso === "null" ? null : WebPreLoaderData.currencyCodeIso,
                applicationId: WebPreLoaderData.applicationId,
                nativeApp : null, //{token, os, osVersion}}
                tokenAdmin: null, //if defined the web site works in admin mode   defined by WebSiteAdminCtrl
                adminEdition: false,
                adminPanel: false,
                msgErrorService: "",
                msgErrorCategory: "",
                locationPath : $location.path(),
                dialog: {
                    cure: false,
                    product: false,
                    giftItems: false,
                    loyaltyCard: false,
                    customerPost: false,
                    contact: false,
                    hour: false,
                    payment: false,
                    creative: false
                },
                subscriptions : WebPreLoaderData.subscriptionsStatus === "null" ? null : WebPreLoaderData.subscriptionsStatus,
                brand: Brand,
                offerManager: OfferManager,
                storeAppCode: StoreAppCode,
                type: WebPreLoaderData.type,
                marketplaceUrl: WebPreLoaderData.marketplaceUrl,
        }
            $scope.isValidCustomerEmail = function () {
                let regex = new RegExp(Constants.EMAIL, 'i');
                return regex.test($scope.ad.view.customerView.email);
            }
            $scope.isEnglishLanguage = function () {
                return LanguageManager.isEnglishLanguage();
            };

            $scope.isFrenchLanguage = function () {
                return LanguageManager.isFrenchLanguage();
            };

            $scope.isFrenchLocation = function(country)
            {
                if(country === Countries.FRANCE.countryCode){
                    return true;
                }
                else {
                    return false;
                }
            };

            $scope.getCurrencySymbol = function(){
                return CurrencyManager.getCurrencySymbol();
            };

            $scope.hasSubscriptionItem = function(itemCode){
                let subscriptionsStatusIsActive = false;
                if (WebPreLoaderData.subscriptionsStatus) {
                    for (let i = 0; i < WebPreLoaderData.subscriptionsStatus.length; i++){
                        if(WebPreLoaderData.subscriptionsStatus[i]){
                            if(WebPreLoaderData.subscriptionsStatus[i].storeAppCode === itemCode){
                                subscriptionsStatusIsActive = WebPreLoaderData.subscriptionsStatus[i].isActive;
                            }
                        }
                    }
                }
                return subscriptionsStatusIsActive;
            }

            $scope.$on('$routeChangeSuccess', function() {
                // $routeParams should be populated here
                if ($routeParams.nativeAppOsVersion && $routeParams.nativeAppOs) {
                    $scope.ad.nativeApp = {
                        os: $routeParams.nativeAppOs,
                        osVersion: $routeParams.nativeAppOsVersion,
                        token: null
                    };

                    if ($routeParams.nativeAppToken && $routeParams.nativeAppToken!=undefined)
                        $scope.ad.nativeApp.token =$routeParams.nativeAppToken;
                }

            });

            if (WebPreLoaderData.subscriptionsStatus) {
                for (var i = 0; i < WebPreLoaderData.subscriptionsStatus.length; i++)
                    $scope.ad.subscriptionsStatus[WebPreLoaderData.subscriptionsStatus[i].storeAppCode] = WebPreLoaderData.subscriptionsStatus[i].isActive;
                console.log($scope.ad.subscriptionsStatus);
            }

            $scope.initBugsnag = function () {
                try{
                    if (WebPreLoaderData.applicationId && WebPreLoaderData.version) {
                        console.info("Initialisation of bugsnag");
                        if (WebPreLoaderData.applicationId != "bsiflexyprod")
                            bugsnag.releaseStage = "development";
                        bugsnag.appVersion = WebPreLoaderData.version;
                    }
                    bugsnag.user = { id: WebPreLoaderData.companyCode };
                }
                catch(error) {
                    console.error("Erreur during the initialisation of bugsnag");
                    console.error(error);
                }
            };

            $scope.onChange = function (event, items) {

            };

            $scope.initLokalise = function(){
                try{
                    if (LanguageManager.canAccessLiveEdit() && $scope.ad.tokenAdmin){
                        console.info("Initialisation of lokalise");
                        window.LOKALISE_CONFIG = {
                            projectId: "625966535b44b267eeeae8.51499813",
                            locale : LanguageManager.getGetTextLocale()
                        };
                        (function () {
                            var a = document.createElement("script");
                            a.type = "text/javascript";
                            a.async = !0;
                            a.src = ["https://lokalise.co/live-js/script.min.js?", (new Date).getTime()].join("");
                            document.body.appendChild(a)
                        })();
                    }
                }
                catch(error) {
                    console.error("Erreur during the initialisation of lokalise");
                    console.error(error);
                }
            };

            $scope.initFacebook = function(){
                try {
                    console.info("Initialisation of facebook");
                    window.fbAsyncInit = function () {
                        FB.init({
                            appId: '635553289857009',
                            xfbml: true,
                            version: 'v2.3'
                        });
                    };
                    (function (d, s, id) {
                        var js, fjs = d.getElementsByTagName(s)[0];
                        if (d.getElementById(id)) {
                            return;
                        }
                        js = d.createElement(s);
                        js.id = id;
                        js.async = true;
                        if ($scope.ad.companyCountry == "" || $scope.ad.companyCountry == null) {
                            if ($scope.ad.languageCode && $scope.ad.languageCode != 'null' && $scope.ad.languageCode != "fr") {
                                js.src = "//connect.facebook.net/" + $scope.ad.languageCode + "_FR/all.js";
                            }
                            else {
                                js.src = "//connect.facebook.net/fr_FR/all.js";
                            }
                        }
                        else {
                            if ($scope.ad.languageCode && $scope.ad.languageCode != 'null' && $scope.ad.languageCode != "fr") {
                                js.src = "//connect.facebook.net/" + $scope.ad.languageCode + "_" + $scope.ad.companyCountry + "/all.js";
                            }
                            else {
                                js.src = "//connect.facebook.net/fr_" + $scope.ad.companyCountry + "/all.js";
                            }
                        }
                        fjs.parentNode.insertBefore(js, fjs);
                    }(document, 'script', 'facebook-jssdk'));
                }
                catch(error) {
                    console.error("Erreur during the initialisation of facebook");
                    console.error(error);
                }
            };


            //STARTING CODE
            Auth.init(false, WebPreLoaderData.companyCode);
            $scope.initBugsnag();

            Loader.loadWebData(WebPreLoaderData, function () {
                var afterLocalLoad = function(){
                    try {
                        CurrencyManager.set($scope.ad.currencySymbol, $scope.ad.currencyCode, $scope.ad.currencyCodeIso);
                        DateSrv.doReload();
                        $scope.ad.startDate = new Date();
                        var vats = VatData.getActiveList();
                        for (var i = 0; i < vats.length; i++)
                            $scope.ad.view.vatsView.push(new VatView(vats[i], VatData.getIndexOf(vats[i])));
                        var humanResources = $filter('orderBy')(HumanResourceData.getActiveList(), 'order');
                        for (var i = 0; i < humanResources.length; i++)
                            if (humanResources[i].hasPlanning)
                                $scope.ad.view.humanResourcesView.push(new HumanResourceView(humanResources[i], HumanResourceData.getIndexOf(humanResources[i]), this));
                        var physicalResources = $filter('orderBy')(PhysicalResourceData.getActiveList(), 'order');
                        for (var i = 0; i < physicalResources.length; i++)
                            $scope.ad.view.physicalResourcesView.push(new PhysicalResourceView(physicalResources[i], PhysicalResourceData.getIndexOf(physicalResources[i]), this));
                        $scope.ad.view.categoryRootView = new CategoryView(CategoryData.categoryRoot, CategoryData.getIndexOf(CategoryData.categoryRoot), null, $scope);// categoryRoot index  = 0
                        $scope.ad.view.currentCategoryView = $scope.ad.view.categoryRootView;
                        $scope.ad.view.productCategoryRootView = new ProductCategoryView(ProductCategoryData.categoryRoot, ProductCategoryData.getIndexOf(ProductCategoryData.categoryRoot), null, $scope);// categoryRoot index  = 0
                        $scope.ad.view.currentProductCategoryView = $scope.ad.view.productCategoryRootView;
                        $scope.ad.view.cureCategoryRootView = new CureCategoryView(CureCategoryData.categoryRoot, CureCategoryData.getIndexOf(CureCategoryData.categoryRoot), null, $scope);// categoryRoot index  = 0
                        $scope.ad.view.currentCureCategoryView = $scope.ad.view.cureCategoryRootView;
                        $scope.ad.view.loyaltyCardCategoryRootView = new LoyaltyCardCategoryView(LoyaltyCardCategoryData.categoryRoot, LoyaltyCardCategoryData.getIndexOf(LoyaltyCardCategoryData.categoryRoot), null, $scope);// categoryRoot index  = 0
                        $scope.ad.view.currentLoyaltyCardCategoryView = $scope.ad.view.loyaltyCardCategoryRootView;
                        $scope.ad.view.homeItemsView = [];

                        $scope.ad.view.siteView = new SiteView(SiteData.defaultSite);
                        $scope.ad.view.imagesBgTransparentView = ImageData.getActiveList("webSiteBgTransparent");
                        $scope.ad.view.imagesBgOpaqueView = ImageData.getActiveList("webSiteBgOpaque");
                        $scope.ad.view.imagesServiceView = ImageData.getActiveList("");
                        $scope.ad.view.imagesCompanyView = CompanyImageData.companyImages;
                        $scope.ad.view.imagesAboutCompanyView = CompanyImageData.getActiveList("about");
                        $scope.ad.view.imagesBgCompanyView = CompanyImageData.getActiveList("background");
                        $scope.ad.view.imagesWithoutCustomer = CompanyImageData.getActiveListWithoutCustomerImages();

                        $scope.ad.view.categoryRootView.loadProductsView();
                        $scope.loadAppAttributes();
                        $scope.initGoogleAnalyticsObject();
                        $scope.initLokalise();

                        $scope.redirectIfUnactiveStoreApp();

                        $scope.ad.dataLoaded = true;
                        $timeout(function () {
                            $scope.ad.view.loaded = true;
                        }, 200);

                        var setAttributeOnLiveEdit = function () {
                            if ($('#lokalise-live-js-panel').is(':visible')) { //if the container is visible on the page
                                $("#lokalise-live-js-panel").attr("websiteliveedit", true);
                            } else {
                                setTimeout(setAttributeOnLiveEdit, 50); //wait 50 ms, then try again
                            }
                        }
                        angular.element(document).ready(function () {
                            setAttributeOnLiveEdit();
                        });

                        console.timeEnd('globalLoading');

                        MeasureStore.registerEnd(TimeMeasures.MODEL_GLOBAL_TIME);
                        MonitoringSrv.logHealth(MonitoringApplication.WEBSITE, MonitoringHealthState.OK,  JSON.stringify(MeasureStore));

                    }
                    catch(e){
                        MeasureStore.registerEnd(TimeMeasures.MODEL_GLOBAL_TIME);
                        MonitoringSrv.logHealth(MonitoringApplication.WEBSITE, MonitoringHealthState.KO, JSON.stringify(MeasureStore));
                    }
                };

                $scope.initFacebook();
                PhoneFormat.setLocalCountry($scope.ad.companyCountry);

                let afterConnexion = function(){
                    $scope.addHeadersForMangopay();
                    LanguageManager.initLanguageManager($scope.ad.localeCode).then(afterLocalLoad);
                };
                $scope.initConnexion(afterConnexion, afterConnexion);
            });

            $scope.unactiveStoreAppCodes = function() {
                let unactiveStoreAppCodes = [];
                let subscriptions = $scope.ad.subscriptions;
                if(subscriptions && subscriptions.length > 0) {
                    for (let i = 0; i < subscriptions.length; i++) {
                        if (!subscriptions[i].isActive) {
                            unactiveStoreAppCodes.push(subscriptions[i].storeAppCode);
                        }
                    }
                }
                return unactiveStoreAppCodes;
            };

            $scope.fetchProhibatedPaths = function() {
                let webSitePathByStoreAppCode = Constants.WEBSITE_PATH_BY_STORE_APP_CODE;
                let storeAppCodes = Object.keys(webSitePathByStoreAppCode);
                let unactiveStoreAppCodes = $scope.unactiveStoreAppCodes();
                let prohibatedPaths = [];

                for(let i = 0; i < storeAppCodes.length; i++) {
                    if(unactiveStoreAppCodes.includes(storeAppCodes[i])) {
                        let paths = webSitePathByStoreAppCode[storeAppCodes[i]];
                        if (paths && paths.length) {
                            paths.forEach(path => prohibatedPaths.push(path));
                        }
                    }
                }
                return prohibatedPaths;
            };

            $scope.urlWithoutCompanyCode = function() {
                let urlPaths = $location.url().split('/');
                if($scope.ad.companyCode) {
                    let companyCodeIndex = urlPaths.indexOf($scope.ad.companyCode);
                    if (companyCodeIndex === -1) {
                        companyCodeIndex = urlPaths.indexOf($scope.ad.companyCode + "#");
                    }
                    urlPaths.splice(0, companyCodeIndex + 1);
                }
                return urlPaths;
            };

            $scope.isRedirectionNeeded = function() {
                let urlPaths = $scope.urlWithoutCompanyCode();
                let prohibatedPaths = $scope.fetchProhibatedPaths();
                let isRedirectionNeeded = false;
                for(let i = 0; i < prohibatedPaths.length; i++) {
                    if(urlPaths.includes(prohibatedPaths[i])) {
                        isRedirectionNeeded = true;
                    }
                }
                return isRedirectionNeeded;
            };

            $scope.redirectIfUnactiveStoreApp = function() {
                let isRedirectionNeeded = $scope.isRedirectionNeeded();
                if (isRedirectionNeeded) {
                    $scope.openLocation('/home');
                }
            };

            $scope.removeGiftItemImageCompanyView  = function(companyImage)
            {
                    let opts = {
                        backdrop: true,
                        keyboard: true,
                        backdropClick: false,
                        templateUrl:  '/partials/global/removeConfirm.html',
                        controller: 'DialogCtrl' ,
                        resolve: {
                            dialogsModel: function() {
                                let tableModel = [] ;
                                tableModel["label"] = companyImage.label;
                                return tableModel;
                            }}},
                    d = $dialog.dialog(opts);
                    d.open().then(function(result){
                        if (result)
                        {
                            let index = $scope.ad.view.imagesCompanyView.indexOf(companyImage);
                            if (index !== -1)
                            {
                                $scope.ad.view.imagesCompanyView.splice(index,1);
                                CompanyImageSrv.remove(companyImage);
                            }
                        }
                    });
            };


            $scope.initConnexion = function (successFunction, failureFunction) {
                if (!$scope.ad.nativeApp) {
                    $.cookieBar({
                        message: gettextCatalog.getString("En poursuivant votre navigation, vous acceptez l'utilisation de cookies."),
                        acceptText: gettextCatalog.getString("J'ai compris"),
                        acceptAnyClick: true
                    });
                } else {
                    //Manage special mobile mode during ios validation
                    if (!$scope.ad.subscriptionsStatus.nativeApp)
                    {
                        if ($scope.ad.view.categoryRootView)
                            $scope.ad.view.categoryRootView.initWebDisplay("array");// force array displayType when nativeApp not set to true for allow apple validation
                        if ($scope.ad.view.productCategoryRootView)
                            $scope.ad.view.productCategoryRootView.initWebDisplay("array");// force array displayType when nativeApp not set to true for allow apple validation
                        if ($scope.ad.view.cureCategoryRootView)
                            $scope.ad.view.cureCategoryRootView.initWebDisplay("array");// force array displayType when nativeApp not set to true for allow apple validation
                        $scope.ad.appAttributes.hasGiftItem = false;// hide for i
                        $scope.ad.appAttributes.homeOffer = false;
                        $scope.ad.appAttributes.homeCure = false;
                        $scope.ad.appAttributes.homeProduct = false;
                        $scope.ad.appAttributes.homeLoyaltyCard = false;
                    }
                }

                if ($scope.ad.tokenAdmin) {
                    $scope.ad.view.gridOptions.disableResize = false;
                    $scope.ad.view.gridOptions.disableDrag = false;
                    if(successFunction)
                        successFunction();

                }
                else {
                    if (!$route.current.params.token && !$route.current.params.id) {//not auto logging with a link
                        let user = Auth.getCurrentUser();
                        if (user) {
                            if (user.id) {
                                CustomerSrv.get(user.id,
                                    function (customer) {
                                        $scope.afterGetCustomerWithSuccess(customer);
                                        if (successFunction)
                                            successFunction();
                                    }, function () {
                                        CustomerSrv.getByEmail(user.email,
                                            function (customer) {//success by mail
                                                $scope.afterGetCustomerWithSuccess(customer);
                                                if (successFunction)
                                                    successFunction();
                                            },
                                            function () { //error
                                                //remove cookie and login Anonymous
                                                console.log("login official error");
                                                Auth.clearWebSiteUser(WebPreLoaderData.companyCode);
                                                $scope.loginAnonymous(successFunction, failureFunction);
                                            })
                                    }
                                );
                            }
                            else { //Try by email
                                CustomerSrv.getByEmail(user.email,
                                    $scope.afterGetCustomerWithSuccess,//success by mail
                                    function () { //error
                                        //remove cookie and login Anonymous
                                        console.log("login official error");
                                        Auth.clearWebSiteUser(WebPreLoaderData.companyCode);
                                        $scope.loginAnonymous(successFunction, failureFunction);
                                    })
                            }
                        }
                        else {
                            $scope.loginAnonymous(successFunction, failureFunction);
                        }
                    } else {
                        $scope.ad.view.loaded = true;
                        if (successFunction)
                            successFunction();
                    }
                }
            };

            $scope.initGoogleAnalyticsObject = function () {
                try{
                    if ($scope.ad.appAttributes.googleAnalyticsId) {
                        console.info("Initialisation of googleAnalytics");
                        let element = '<iframe src="https://www.googletagmanager.com/ns.html?id=' + $scope.ad.appAttributes.googleAnalyticsId + '" height="0" width="0" style="display:none;visibility:hidden"></iframe>';
                        let mover = angular.element(element);
                        let body = angular.element(document).find('body').eq(0);
                        body.append(mover);
                        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                        })(window,document,'script','dataLayer',$scope.ad.appAttributes.googleAnalyticsId);

                        window.dataLayer = window.dataLayer || [];
                        function gtag(){dataLayer.push(arguments);}
                        gtag('js', new Date());
                        gtag('config', $scope.ad.appAttributes.googleAnalyticsId);
                    }
                }
                catch(error) {
                    console.error("Erreur during the initialisation of googleAnalytics");
                    console.error(error);
                }
            };


            $scope.afterGetCustomerWithSuccess = function (customer) {
                if ($scope.ad.nativeApp && $scope.ad.nativeApp.token)
                    MobileDeviceSrv.setCustomer($scope.ad.nativeApp,customer.id);
                $scope.ad.view.customerView = new CustomerView();
                $scope.ad.view.customerView.domainView = $scope;
                $scope.ad.view.customerView.loadDataFrom(customer);
                $scope.ad.view.customerView.cIndex = CustomerData.getIndexOf(customer);
                $scope.ad.view.customerView.password = null;//hide by security
                $scope.ad.customerConnected = true;

                bugsnag.user = {
                    id: WebPreLoaderData.companyCode,
                    email: $scope.ad.view.customerView.email
                };
            };
            $scope.loginAnonymous = function (successFunction, failureFunction) {
                Auth.loginToWebSite(WebPreLoaderData.companyCode, null, function (res) {
                    //Anonymous login
                    $scope.ad.view.loaded = true;
                    if(successFunction)
                        successFunction();
                },
                function (errorMessage) {
                    $scope.processing = false;
                    if(failureFunction)
                        failureFunction();
                });
            };
            $scope.logout = function () {
                if ($scope.ad.customerConnected && $scope.ad.view.customerView)
                    Auth.logoutFromWeb($scope.ad.view.customerView.getModel(), WebPreLoaderData.companyCode, function () {
                        $scope.ad.customerConnected = false;
                        $scope.ad.view.customerView = null;

                        //$timeout($scope.loginAnonymous(), 0, false);
                        $window.open("/" + WebPreLoaderData.companyCode + "/login", "_self");
                    });
            }
            $scope.getDefaultVatTax = function () {
                for (var i = 0; i < $scope.ad.view.vatsView.length; i++)
                    if ($scope.ad.view.vatsView[i].isDefault)
                        return $scope.ad.view.vatsView[i].tax;
                return null;
            };
            $scope.getVatsView = function () {
                return $scope.ad.view.vatsView;
            };
            $scope.getDefaultVatView = function () {
                for (var i = 0; i < $scope.ad.view.vatsView.length; i++)
                    if ($scope.ad.view.vatsView[i].isDefault)
                        return $scope.ad.view.vatsView[i];

            };
            $scope.getVatView = function (vat) {
                for (var i = 0; i < $scope.ad.view.vatsView.length; i++)
                    if ($scope.ad.view.vatsView[i].getModel() === vat)
                        return $scope.ad.view.vatsView[i];

                // Not found : instanciate (could be a deleted)
                var vatView = new VatView(vat, VatData.getIndexOf(vat));
                if (!vat.isDeleted)
                    $scope.ad.view.vatsView.push(vatView);
                return vatView;
            };
            $scope.getHrView = function (hr) {
                var hrView = null;
                if (hr) {
                    for (var i = 0; i < $scope.ad.view.humanResourcesView.length; i++)
                        if ($scope.ad.view.humanResourcesView[i].getModel() === hr)
                            return $scope.ad.view.humanResourcesView[i];
                }
                return hrView;
            };
            $scope.getHumanResourcesView = function () {
                return $scope.ad.view.humanResourcesView;
            }

            $scope.getPhysicalResourcesView = function () {
                return $scope.ad.view.physicalResourcesView;
            }
            $scope.getCustomerView = function () {
                return $scope.ad.view.customerView;
            }
            $scope.getServiceView = function (service) {
                return $scope.ad.view.categoryRootView.getServiceView(service);
            };
            $scope.getServiceViewById = function (id) {
                return $scope.ad.view.categoryRootView.getServiceViewById(id);
            };
            $scope.getCategoryViewById = function (id) {
                return $scope.ad.view.categoryRootView.getCategoryViewById(id);
            };
            $scope.getProductViewById = function (id) {
                return $scope.ad.view.productCategoryRootView.getProductViewById(id);
            };
            $scope.getProductCategoryViewById = function (id) {
                return $scope.ad.view.productCategoryRootView.getCategoryViewById(id);
            };
            $scope.getCureViewById = function (id) {
                return $scope.ad.view.cureCategoryRootView.getCureViewById(id);
            };
            $scope.getCureCategoryViewById = function (id) {
                return $scope.ad.view.cureCategoryRootView.getCategoryViewById(id);
            };
            $scope.getLoyaltyCardViewById = function (id) {
                return $scope.ad.view.loyaltyCardCategoryRootView.getLoyaltyCardViewById(id);
            };
            $scope.getLoyaltyCardCategoryViewById = function (id) {
                return $scope.ad.view.loyaltyCardCategoryRootView.getCategoryViewById(id);
            };
            $scope.getProductView = function (product) {
                return $scope.ad.view.productCategoryRootView.getProductView(product);
            };
            $scope.getHasHr = function () {
                return $scope.ad.view.humanResourcesView && $scope.ad.view.humanResourcesView.length != 0;
            }
            $scope.getCureView = function (cure) {
                return $scope.ad.view.cureCategoryRootView.getCureView(cure);
            };
            $scope.getLoyaltyCardView = function (lc) {
                return $scope.ad.view.loyaltyCardCategoryRootView.getLoyaltyCardView(lc);
            }

            $scope.getImagesViewById = function (id) {
                let img = $scope.getImagesServiceViewById(id);
                return (img) ? img : $scope.getImagesCompanyViewById(id);
            }

            $scope.getImagesCompanyViewById = function (id) {
                for (var i = 0; i < $scope.ad.view.imagesCompanyView.length; i++)
                    if ($scope.ad.view.imagesCompanyView[i].id == id)
                        return $scope.ad.view.imagesCompanyView[i];
            }

            $scope.getImagesServiceViewById = function (id) {
                for (var i = 0; i < $scope.ad.view.imagesServiceView.length; i++)
                    if ($scope.ad.view.imagesServiceView[i].id == id)
                        return $scope.ad.view.imagesServiceView[i];
            }
            $scope.getImagesGiftViewById = function (id) {
                for (var i = 0; i < $scope.ad.view.imagesGiftView.length; i++)
                    if ($scope.ad.view.imagesGiftView[i].id == id)
                        return $scope.ad.view.imagesGiftView[i];
            };

            $scope.unactiveImagesServiceView = function () {
                for (var i = 0; i < $scope.ad.view.imagesServiceView.length; i++)
                    $scope.ad.view.imagesServiceView[i].active = false;
            }

            $scope.unactiveImagesGiftView = function () {
                for (var i = 0; i < $scope.ad.view.imagesGiftView.length; i++)
                    $scope.ad.view.imagesGiftView[i].active = false;
            }
            $scope.actionOnWidgetView = function (widgetView, force) {
                if ((force ||  !$scope.ad.adminEdition) && widgetView && widgetView.object && widgetView.objectType)
                    switch (widgetView.objectType) {
                        case "service":
                            $scope.setCurrentServiceView(widgetView.object, true);
                            break;
                        case "category":
                            $scope.setCurrentCategoryView(widgetView.object, true);
                            break;
                        case "productCategory":
                            $scope.setCurrentProductCategoryView(widgetView.object, true);
                            break;
                        case "product":
                            $scope.setCurrentProductView(widgetView.object, true);
                            break;
                        case "loyaltyCard":
                            $scope.setCurrentLoyaltyCardView(widgetView.object, true);
                            break;
                        case "loyaltyCardCategory":
                            $scope.setCurrentLoyaltyCardCategoryView(widgetView.object, true);
                            break;
                        case "cureCategory":
                            $scope.setCurrentCureCategoryView(widgetView.object, true);
                            break;
                        case "cure":
                            $scope.setCurrentCureView(widgetView.object, true);
                            break;
                        case "gift":
                            if (typeof widgetView.object === "string")
                                $scope.openLocation('giftItem/type/' + widgetView.object);
                            break;
                    }
            }
            $scope.setCurrentCategoryView = function (categoryView, gotoPath) {
                $scope.ad.view.currentCategoryView = categoryView;
                if (categoryView.parentCategoryView != null)
                    categoryView.parentCategoryView.showMenu = false;
                if (categoryView.servicesView.length > 0) {
                    categoryView.selectedServiceView = categoryView.servicesView.find((serviceView) => serviceView.isVisibleOnWebSite);
                }
                $scope.ad.view.currentParentCategoriesViewTree = [];
                var cTreeView = categoryView;
                if (cTreeView.parentCategoryView)
                    while (cTreeView.parentCategoryView != null) {
                        $scope.ad.view.currentParentCategoriesViewTree.splice(0, 0, cTreeView.parentCategoryView);
                        cTreeView = cTreeView.parentCategoryView;
                    }
                if (gotoPath)
                    $scope.openLocation("category/" + categoryView.getModel().getId())

            }

            $scope.setCurrentCureCategoryView = function (categoryView, gotoPath) {
                if (OfferManager.hasAccessToFeature($scope.ad.subscriptions, StoreAppCode.OPTION_WEBSITE_PAYMENT)) {
                    $scope.ad.view.adminEditPanelPageTab = 4;
                    $scope.ad.view.currentCureCategoryView = categoryView;
                    if (categoryView.parentCategoryView != null)
                        categoryView.parentCategoryView.showMenu = false;
                    if (categoryView.curesView.length > 0)
                        categoryView.selectedCureView = categoryView.curesView[0];
                    $scope.ad.view.currentParentCategoriesViewTree = [];
                    var cTreeView = categoryView;
                    if (cTreeView.parentCategoryView)
                        while (cTreeView.parentCategoryView != null) {
                            $scope.ad.view.currentParentCategoriesViewTree.splice(0, 0, cTreeView.parentCategoryView);
                            cTreeView = cTreeView.parentCategoryView;
                        }
                    if (gotoPath) {
                        $scope.openLocation("cureCategory/" + categoryView.getModel().getId());
                    }
                }
            };

            $scope.openHomeLocation = function() {
                $scope.openLocation("/home");
            }

            $scope.redirectToHomeWhenAccessIsNotGranted = function () {
                if (!OfferManager.hasAccessToFeature($scope.ad.subscriptions, StoreAppCode.OPTION_WEBSITE_PAYMENT)) {
                    $scope.openHomeLocation();
                }
            };

            $scope.setCurrentProductCategoryView = function (categoryView, gotoPath) {
                if (OfferManager.hasAccessToFeature($scope.ad.subscriptions, StoreAppCode.OPTION_WEBSITE_PAYMENT)) {
                    $scope.ad.view.adminEditPanelPageTab = 5;
                    $scope.ad.view.currentProductCategoryView = categoryView;
                    if (categoryView.parentCategoryView != null)
                        categoryView.parentCategoryView.showMenu = false;
                    if (categoryView.productsView.length > 0)
                        categoryView.selectedProductView = categoryView.productsView[0];
                    $scope.ad.view.currentParentCategoriesViewTree = [];
                    var cTreeView = categoryView;
                    if (cTreeView.parentCategoryView)
                        while (cTreeView.parentCategoryView != null) {
                            $scope.ad.view.currentParentCategoriesViewTree.splice(0, 0, cTreeView.parentCategoryView);
                            cTreeView = cTreeView.parentCategoryView;
                        }
                    if (gotoPath) {
                        $scope.openLocation("productCategory/" + categoryView.getModel().getId());
                    }
                }
            };

            $scope.setCurrentLoyaltyCardCategoryView = function (categoryView, gotoPath) {
                if (OfferManager.hasAccessToFeature($scope.ad.subscriptions, StoreAppCode.OPTION_WEBSITE_PAYMENT)) {
                    $scope.ad.view.adminEditPanelPageTab = 7;
                    $scope.ad.view.currentLoyaltyCardCategoryView = categoryView;
                    if (categoryView.parentCategoryView != null)
                        categoryView.parentCategoryView.showMenu = false;
                    if (categoryView.loyaltyCardsView.length > 0)
                        categoryView.selectedLoyaltyCardView = categoryView.loyaltyCardsView[0];
                    $scope.ad.view.currentParentCategoriesViewTree = [];
                    var cTreeView = categoryView;
                    if (cTreeView.parentCategoryView)
                        while (cTreeView.parentCategoryView != null) {
                            $scope.ad.view.currentParentCategoriesViewTree.splice(0, 0, cTreeView.parentCategoryView);
                            cTreeView = cTreeView.parentCategoryView;
                        }
                    if (gotoPath) {
                        $scope.openLocation("loyaltyCardCategory/" + categoryView.getModel().getId())
                    }
                }
            };

            $scope.setCurrentPanelPageView = function (gotoPath,tab) {
                if (OfferManager.hasAccessToFeature($scope.ad.subscriptions, StoreAppCode.OPTION_WEBSITE_PAYMENT)) {
                    $scope.ad.view.adminEditPanelPageTab = tab;
                    if (gotoPath) {
                        $scope.openLocation(gotoPath);
                    }
                }
            };

            $scope.setCurrentPageServiceView = function (gotoPath,tab) {
                if (OfferManager.hasAccessToFeature($scope.ad.subscriptions, StoreAppCode.OPTION_WEBSITE_PAYMENT)) {
                    $scope.ad.view.adminEditPanelPageServiceTab = tab;
                    if (gotoPath) {
                        $scope.openLocation(gotoPath);
                    }
                }
            };

            $scope.onAllowChooseHrChange = function () {
                let displayAllowChooseHrMessageSpecification = new WebSiteSpecifications.DisplayAllowChooseHrMessageSpecification();
                if (displayAllowChooseHrMessageSpecification.isSatisfiedBy($scope.ad.appAttributes.allowChooseHr, $scope.ad.subscriptionsStatus.optionLeCiseau)) {
                    let question;
                    if ($scope.ad.subscriptionsStatus.optionReserveWithGoogle) {
                        question = gettextCatalog.getString("Le choix du professionnel sera désactivé sur votre site {{brandLabel}} et sur {{allowChooseHrDesactivatedPartnerName}} mais pas sur la plateforme {{allowChooseHrNotDesactivatedPartnerName}}.",
                            {brandLabel: $scope.ad.brand.label, allowChooseHrDesactivatedPartnerName : BasicAuthRole.GOOGLE_ROLE.label, allowChooseHrNotDesactivatedPartnerName : BasicAuthRole.LE_CISEAU_ROLE.label});
                    } else {
                        question = gettextCatalog.getString("Le choix du professionnel sera désactivé sur votre site {{brandLabel}} mais pas sur la plateforme {{allowChooseHrNotDesactivatedPartnerName}}.",
                            {brandLabel: $scope.ad.brand.label, allowChooseHrNotDesactivatedPartnerName: BasicAuthRole.LE_CISEAU_ROLE.label});
                    }
                    let description = gettextCatalog.getString("Confirmez-vous votre choix ? ");
                    let noMessage = gettextCatalog.getString("Annuler");
                    let yesMessage = gettextCatalog.getString("Confirmer");

                    let opts = {
                        backdrop: true,
                        keyboard: true,
                        backdropClick: false,
                        templateUrl: '/partials/global/generalConfirm.html',
                        controller: 'DialogCtrl',
                        resolve: {
                            dialogsModel: function () {
                                let tableModel = [];
                                tableModel["question"] = question;
                                tableModel["description"] = description;
                                tableModel["noMessage"] = noMessage;
                                tableModel["yesMessage"] = yesMessage;
                                return tableModel;
                            }
                        }
                    };

                    let d = $dialog.dialog(opts);
                    d.open().then(function (responseOk) {
                        if (!responseOk) {
                            $scope.ad.appAttributes.allowChooseHr = !$scope.ad.appAttributes.allowChooseHr;
                        }
                        else {
                            let webSiteApp = $scope.computeWebSiteApp();
                            $scope.saveAppAttr(webSiteApp, AppCode.WEBSITE_ATTRIBUTE_ALLOW_CHOOSE_HR);
                            AppSrv.save(webSiteApp);
                        }
                    });
                }
            };

            $scope.computeWebSiteApp = function() {
                let webSiteApp = AppData.getAppByCode(AppCode.WEBSITE_APP);
                if (!webSiteApp) {
                    webSiteApp = new App();
                    webSiteApp.setCode(AppCode.WEBSITE_APP);
                }
                return webSiteApp;
            };

            $scope.setCurrentDialog = function (dialogName) {
                if (!OfferManager.hasAccessToFeature($scope.ad.subscriptions, StoreAppCode.OPTION_WEBSITE_PAYMENT)) {
                    for (let dialog in $scope.ad.dialog) {
                        if (dialog === dialogName) {
                            $scope.ad.dialog[dialog] = !$scope.ad.dialog[dialog];
                        } else {
                            $scope.ad.dialog[dialog] = false;
                        }
                    }
                }
            };

            $scope.setCurrentServiceView = function (serviceView, gotoPath) {
                $scope.ad.view.currentServiceView = serviceView;
                if (serviceView.parentCategoryView != null)
                    serviceView.parentCategoryView.showMenu = false;
                $scope.ad.view.currentParentCategoriesViewTree = [serviceView.parentCategoryView];
                var cTreeView = serviceView.parentCategoryView;
                if (cTreeView.parentCategoryView)
                    while (cTreeView.parentCategoryView != null) {
                        $scope.ad.view.currentParentCategoriesViewTree.splice(0, 0, cTreeView.parentCategoryView);
                        cTreeView = cTreeView.parentCategoryView;
                    }
                if (gotoPath)
                    $scope.openLocation("service/" + serviceView.getModel().getId());
            }
            $scope.setCurrentProductView = function (productView, gotoPath) {
                $scope.ad.view.currentProductView = productView;
                if (productView.parentCategoryView != null)
                    productView.parentCategoryView.showMenu = false;
                $scope.ad.view.currentParentCategoriesViewTree = [productView.parentCategoryView];
                var cTreeView = productView.parentCategoryView;
                if (cTreeView.parentCategoryView)
                    while (cTreeView.parentCategoryView != null) {
                        $scope.ad.view.currentParentCategoriesViewTree.splice(0, 0, cTreeView.parentCategoryView);
                        cTreeView = cTreeView.parentCategoryView;
                    }
                if (gotoPath)
                    $scope.openLocation("product/" + productView.getModel().getId());
            }

            $scope.setCurrentCureView = function (cureView, gotoPath) {
                $scope.ad.view.currentCureView = cureView;
                if (cureView.parentCategoryView != null)
                    cureView.parentCategoryView.showMenu = false;
                $scope.ad.view.currentParentCategoriesViewTree = [cureView.parentCategoryView];
                var cTreeView = cureView.parentCategoryView;
                if (cTreeView.parentCategoryView)
                    while (cTreeView.parentCategoryView != null) {
                        $scope.ad.view.currentParentCategoriesViewTree.splice(0, 0, cTreeView.parentCategoryView);
                        cTreeView = cTreeView.parentCategoryView;
                    }
                if (gotoPath)
                    $scope.openLocation("cure/" + cureView.getModel().getId());
            }
            $scope.setCurrentLoyaltyCardView = function (loyaltyCardView, gotoPath) {
                $scope.ad.view.currentLoyaltyCardView = loyaltyCardView;
                if (loyaltyCardView.parentCategoryView != null)
                    loyaltyCardView.parentCategoryView.showMenu = false;
                $scope.ad.view.currentParentCategoriesViewTree = [loyaltyCardView.parentCategoryView];
                var cTreeView = loyaltyCardView.parentCategoryView;
                if (cTreeView.parentCategoryView)
                    while (cTreeView.parentCategoryView != null) {
                        $scope.ad.view.currentParentCategoriesViewTree.splice(0, 0, cTreeView.parentCategoryView);
                        cTreeView = cTreeView.parentCategoryView;
                    }
                if (gotoPath)
                    $scope.openLocation("loyaltyCard/" + loyaltyCardView.getModel().getId());
            }

            $scope.addServiceViewIndex = function (serviceView) {
                $scope.ad.view.servicesViewIndex.push(serviceView);
            };
            $scope.addProductViewIndex = function (productView) {
                $scope.ad.view.productsViewIndex.push(productView);
            };
            $scope.addCureViewIndex = function (cureView) {
                $scope.ad.view.curesViewIndex.push(cureView);
            };
            $scope.onSearchInputKeyDown = function (event) {
                if (event.keyCode != 13)
                    return;
                // this will finish the current digest before triggering the blur
                $timeout(function () {
                    event.target.blur()
                }, 0, false);
                $scope.openLocation("searchedServices");
            };

            $scope.openLocation = function (location) {
                //CHECK START DATE < 1h;
                var now = new Date();
                if (!$scope.ad.tokenAdmin && ($scope.ad.startDate && ((now.getTime() - $scope.ad.startDate.getTime()) > 3600000)))//3600000
                    if ($scope.ad.nativeApp)
                        if ($scope.ad.nativeApp.token)
                            $window.open("/" + $scope.ad.companyCode + "/nativeApp/" + $scope.ad.nativeApp.os+ "/"+ $scope.ad.nativeApp.osVersion+ "/" + $scope.ad.nativeApp.token, "_self");//FORCE RELOAD ON HOME
                        else
                            $window.open("/" + $scope.ad.companyCode + "/nativeApp/" + $scope.ad.nativeApp.os+ "/"+ $scope.ad.nativeApp.osVersion, "_self");//FORCE RELOAD ON HOME

                    else
                        $window.open("/" + $scope.ad.companyCode + "/" + location, "_self");//FORCE RELOAD
                else {
                    var index = $location.path().indexOf(WebPreLoaderData.companyCode); //get index of second /
                    if (index != -1)//by example html5mode activate
                        $location.path("/" + WebPreLoaderData.companyCode + "/" + location);
                    else
                        $location.path("/" + location);

                    $anchorScroll();
                }

            };
            $scope.reloadLocation = function () {
                $route.reload();
            };
            $scope.scrollTo = function (target) {
                var obj = $(target);
                if (obj && obj.offset())
                    $('html,body').animate({
                        scrollTop: obj.offset().top
                    },
                        'slow');
            }
            $scope.getHrefPath = function (location) {
                let hrefPath = "";
                if(!WebPreLoaderData.isBehindReverseProxy)
                {
                    hrefPath = "/" + WebPreLoaderData.companyCode; //by example html5mode activate
                    if($location.path().indexOf(WebPreLoaderData.companyCode) === -1)
                        hrefPath += "#";
                }
                return hrefPath + "/" + location;
            };


            //search
            $scope.searchWebItem = function (itemView) {
                if (itemView && $scope.ad.view.searchedText)
                    return itemView.search($scope.ad.view.searchedText.toLowerCase());
                return false;
            };




            $scope.loadHomeTextHtml = function () {
                var webSiteApp = AppData.getAppByCode("webSite");
                if (webSiteApp) {
                    var appAttr = webSiteApp.getAppAttribute("homeTextHtml");
                    if (appAttr)
                        if (appAttr.text && appAttr.text != '')
                            $scope.ad.appAttributes.homeTextHtml = (appAttr.text);
                        else
                            $scope.ad.appAttributes.homeTextHtml = "";
                }
            };
            $scope.loadCgvHtml = function () {
                var webSiteApp = AppData.getAppByCode("webSite");
                if (webSiteApp) {
                    var appAttr = webSiteApp.getAppAttribute("cgv");
                    if (appAttr && appAttr.text && appAttr.text != '')
                        $scope.ad.appAttributes.cgvHtml = $sce.trustAsHtml(appAttr.text);
                }
            };
            $scope.loadTitle = function (webSiteApp) {
                if (!webSiteApp)
                    webSiteApp = AppData.getAppByCode("webSite");
                if (webSiteApp) {
                    var appAttr = webSiteApp.getAppAttribute("titleIsDisplayed");
                    if (appAttr)
                        $scope.ad.appAttributes.titleIsDisplayed = (appAttr.value == "true");
                    appAttr = webSiteApp.getAppAttribute("titleHomeLabel");
                    if (appAttr) {
                        $scope.ad.appAttributes.titleHomeLabel = (appAttr.value);

                    }
                    appAttr = webSiteApp.getAppAttribute("titleBgColorStart");
                    if (appAttr)
                        $scope.ad.appAttributes.titleBgColorStart = appAttr.value;
                    appAttr = webSiteApp.getAppAttribute("titleBgColorEnd");
                    if (appAttr)
                        $scope.ad.appAttributes.titleBgColorEnd = appAttr.value;
                    appAttr = webSiteApp.getAppAttribute("titleFontColor");
                    if (appAttr)
                        $scope.ad.appAttributes.titleFontColor = appAttr.value;
                }
                else {
                    $scope.ad.appAttributes.titleHomeLabel = "Carte des soins";
                    $scope.ad.appAttributes.titleIsDisplayed = true;
                    $scope.ad.appAttributes.titleBgColorStart = "#ff3399";
                    $scope.ad.appAttributes.titleBgColorEnd = "#993366";
                    $scope.ad.appAttributes.titleFontColor = "#ffffff";
                }
                $scope.ad.view.categoryRootView.label = $scope.ad.appAttributes.servicesLabel;
                $scope.ad.view.productCategoryRootView.label = $scope.ad.appAttributes.productsLabel;
                $scope.ad.view.cureCategoryRootView.label = $scope.ad.appAttributes.curesLabel;
                $scope.ad.view.loyaltyCardCategoryRootView.label = $scope.ad.appAttributes.loyaltyCardsLabel;
            };

            $scope.loadMenu = function (webSiteApp) {
                if (!webSiteApp)
                    webSiteApp = AppData.getAppByCode("webSite");
                if (webSiteApp) {
                    var appAttr = webSiteApp.getAppAttribute("menuIsDisplayed");
                    if (appAttr)
                        $scope.ad.appAttributes.menuIsDisplayed = (appAttr.value == "true");
                    appAttr = webSiteApp.getAppAttribute("menuBgColorStart");
                    if (appAttr)
                        $scope.ad.appAttributes.menuBgColorStart = appAttr.value;
                    else
                        $scope.ad.appAttributes.menuBgColorStart = null;
                    appAttr = webSiteApp.getAppAttribute("menuBgColorEnd");
                    if (appAttr)
                        $scope.ad.appAttributes.menuBgColorEnd = appAttr.value;
                    else
                        $scope.ad.appAttributes.menuBgColorEnd = null;
                    appAttr = webSiteApp.getAppAttribute("menuFontColor");
                    if (appAttr)
                        $scope.ad.appAttributes.menuFontColor = appAttr.value;
                    else
                        $scope.ad.appAttributes.menuFontColor = null;
                    appAttr = webSiteApp.getAppAttribute("menuShadowColor");
                    if (appAttr)
                        $scope.ad.appAttributes.menuShadowColor = appAttr.value;
                    else
                        $scope.ad.appAttributes.menuShadowColor = null;
                }
                else {
                    $scope.ad.appAttributes.menuIsDisplayed = true;
                    $scope.ad.appAttributes.menuBgColorStart = "#FFFFFF";
                    $scope.ad.appAttributes.menuBgColorEnd = "#FFFFFF";
                    $scope.ad.appAttributes.menuFontColor = "#000000";
                }
            };


            $scope.updateDiscountDays = function () {
                var discountDays = $scope.ad.view.aTableView.getDiscountDays();

                var oldDiscountDays = $scope.ad.appAttributes.discountDays;
                var nowDayId = DaySrv.getIdFromDate(new Date());
                if (oldDiscountDays) {
                    var insideNew;
                    var newADaysView = discountDays.aDaysView.slice(0);
                    for (var i = 0; i < oldDiscountDays.aDaysView.length; i++) {
                        insideNew = false;
                        for (var j = 0; j < discountDays.aDaysView.length && !insideNew; j++)
                            insideNew = (oldDiscountDays.aDaysView[i].dayId == discountDays.aDaysView[j].dayId);
                        if (!insideNew && oldDiscountDays.aDaysView[i].dayId >= nowDayId)
                            newADaysView.push(oldDiscountDays.aDaysView[i]);
                    }
                    $scope.ad.appAttributes.discountDays.aDaysView = newADaysView;
                }
                else
                    $scope.ad.appAttributes.discountDays = discountDays;

            };
            $scope.getMondayAsLabel = function (d) {
                d = new Date(d);
                var day = d.getDay(),
                    diff = d.getDate() - day + 1; //don't adjust when day is sunday
                return $filter('date')(new Date(d.setDate(diff)), 'EEEE d MMMM');//execute angular filter $scope.getDayAsLabel());
            };
            $scope.displayWeekOnAdmin = function (next) {
                if ($scope.ad.view.currentBookingView != null) {
                    var date = new Date($scope.ad.view.currentBookingView.date);
                    if (next)
                        date.setDate(date.getDate() + 7);
                    else
                        date.setDate(date.getDate() - 7);

                    if (DateSrv.daysBetween(date, new Date()) > (7 * $scope.ad.appAttributes.nbBookingWeeks)) {
                        $scope.dd.view.warningBookingWeek = true;
                    }
                    else {
                        $scope.ad.view.currentBookingView.date = date;
                        var selectedHr = null;
                        if ($scope.ad.view.aTableView && $scope.ad.view.aTableView.selected && $scope.ad.appAttributes.allowChooseHr)//preserve hr selection when go to next week
                            selectedHr = $scope.ad.view.aTableView.selected.humanResourceView;
                        $scope.ad.view.aTableView = null;
                        DaySrv.getAvailablePeriods(date, 7, next,
                            function (loadedDays, hrSelected, nextDay) {
                                $scope.afterGetAvailablePeriodsOnAdmin(loadedDays, selectedHr, nextDay, next);
                            });
                    }
                }
            };
            $scope.afterGetAvailablePeriodsOnAdmin = function (loadedDays, previousSelectedHr, nextAvailableDay) {
                if (nextAvailableDay && nextAvailableDay !== $scope.ad.view.currentBookingView.date) {
                    $scope.ad.view.currentBookingView.date = nextAvailableDay;
                }

                $scope.ad.view.aTableView = new AvailableTableView(SiteData.defaultSite, $scope);
                var availableHumanResources = [];
                var isAvailable;
                var dayHr;
                var hrId;
                for (var i = 0; i < $scope.ad.view.humanResourcesView.length; i++) {
                    isAvailable = false;
                    hrId = $scope.ad.view.humanResourcesView[i].getModel().id;
                    for (var j = 0; j < loadedDays.length && !isAvailable; j++) {
                        if (loadedDays[j]) {
                            dayHr = loadedDays[j].getDayHrByHrId(hrId);
                            if (dayHr && dayHr.availablePeriods && dayHr.availablePeriods.length > 0)
                                isAvailable = true;
                        }
                    }
                    if (isAvailable)
                        availableHumanResources.push($scope.ad.view.humanResourcesView[i]);

                }
                $scope.ad.view.aTableView.updateAvailability($scope.ad.view.currentBookingView);

                if ($scope.ad.appAttributes.discountDays)
                    $scope.ad.view.aTableView.setByDiscountDays($scope.ad.appAttributes.discountDays);
            }
            $scope.loadAppAttr = function (webSiteApp, appAttrCode, type) {

                var appAttr = webSiteApp.getAppAttribute(appAttrCode);
                if (appAttr) {
                    if (type === undefined || type == "string" || type == "text")
                        if (type === undefined || type == "string")
                            $scope.ad.appAttributes[appAttrCode] = appAttr.value;
                        else
                            $scope.ad.appAttributes[appAttrCode] = appAttr.text;
                    else if (type == "boolean")
                        $scope.ad.appAttributes[appAttrCode] = (appAttr.value == "true");
                    else if (type == "number")
                        if (appAttr.value && appAttr.value != '') {
                            if (typeof appAttr.value === "string")
                                $scope.ad.appAttributes[appAttrCode] = parseFloat(appAttr.value.replace(",", "."));
                            else {
                                if (typeof appAttr.value === "number")
                                    $scope.ad.appAttributes[appAttrCode] = appAttr.value;
                            }
                        }
                        else
                            $scope.ad.appAttributes[appAttrCode] = 0;


                    else if (type == "int")
                        $scope.ad.appAttributes[appAttrCode] = parseInt(appAttr.value);

                }

            }
            $scope.loadHomeGridWidgetsView = function (webSiteApp) {
                if (!webSiteApp)
                    webSiteApp = AppData.getAppByCode("webSite");
                if (webSiteApp) {
                    $scope.ad.view.homeGridWidgetsView = [];

                    var appAttr = webSiteApp.getAppAttribute("homeGridWidgets");
                    if (appAttr && appAttr.text && appAttr.text != '') {
                        let homeGridWidgets = null;
                        try {
                            homeGridWidgets = JSON.parse(appAttr.text);
                        } catch (e) {
                            console.log('loadHomeGridWidgetsView => JSON.parse error' , e);
                        }

                        if (homeGridWidgets) {
                            for (var i = 0; i < homeGridWidgets.length; i++) {
                                var widgetView = new WidgetView(homeGridWidgets[i], i, true, $scope);
                                $scope.ad.view.homeGridWidgetsView.push(widgetView);
                            }
                        }
                    }
                    // sort
                    $scope.ad.view.homeGridWidgetsView = $filter('orderBy')($scope.ad.view.homeGridWidgetsView, ['y', 'x']);
                }
            }
            $scope.loadHomeWidgetView = function (webSiteApp, loadHomeWidgetSub) {
                if (!webSiteApp)
                    webSiteApp = AppData.getAppByCode("webSite");
                if (webSiteApp) {
                    var appAttr = webSiteApp.getAppAttribute("homeWidget");
                    if (appAttr && appAttr.text && appAttr.text != '') {
                        let homeWidget = null;
                        try {
                            homeWidget = JSON.parse(appAttr.text);
                        } catch (e) {
                            console.log('loadHomeWidgetView => JSON.parse error' , e);
                        }

                        if (homeWidget) {
                            if ($scope.ad.view.homeWidgetView && !loadHomeWidgetSub) {
                                var widgetsView = $scope.ad.view.homeWidgetView.widgetsView;
                                $scope.ad.view.homeWidgetView = new WidgetView(homeWidget, 0, loadHomeWidgetSub, $scope);
                                $scope.ad.view.homeWidgetView.widgetsView = widgetsView;
                            }
                            else
                                $scope.ad.view.homeWidgetView = new WidgetView(homeWidget, 0, loadHomeWidgetSub, $scope);
                        }
                    }
                    if (!$scope.ad.view.homeWidgetView) {
                        $scope.ad.view.homeWidgetView = new WidgetView(null, 0, false, $scope);
                        $scope.ad.view.homeWidgetView.type = "default-offer";
                    }
                    else {
                        if ($scope.ad.view.homeWidgetView.type != "default-offer" && $scope.ad.view.homeWidgetView.type != "fullscreen-offer"
                            || $scope.ad.view.homeWidgetView.widgetsView.length == 0)
                            $scope.ad.view.homeWidgetView.type = "default-offer";
                    }

                    var homeItemsView = [];
                    // ascendency compatibily : load object by selecting them
                    $scope.ad.view.categoryRootView.populateHomeItemsView(homeItemsView);
                    $scope.ad.view.productCategoryRootView.populateHomeItemsView(homeItemsView);
                    $scope.ad.view.cureCategoryRootView.populateHomeItemsView(homeItemsView);
                    homeItemsView = $filter('orderBy')(homeItemsView, 'item.homeOrder');
                    $scope.ad.view.homeWidgetView.loadItems(homeItemsView);
                }
            }
            $scope.loadWidgetsView = function (webSiteApp, loadHomeWidgetSub) {
                if (!webSiteApp)
                    webSiteApp = AppData.getAppByCode("webSite");

                if (webSiteApp) {
                    // load widgets
                    var widgetView = null;
                    if ($scope.ad.tokenAdmin) {
                        $scope.ad.view.gridOptions.disableResize = false;
                        $scope.ad.view.gridOptions.disableDrag = false;
                    }

                    $scope.loadHomeGridWidgetsView(webSiteApp);
                    $scope.loadHomeWidgetView(webSiteApp, loadHomeWidgetSub);

                    var appAttr = webSiteApp.getAppAttribute("defaultWidget");
                    if (appAttr && appAttr.text && appAttr.text != '') {
                        let defaultWidget = null;
                        try {
                            defaultWidget = JSON.parse(appAttr.text);
                        } catch (e) {
                            console.log('loadWidgetsView => JSON.parse error' , e);
                        }

                        if (defaultWidget) {
                            $scope.ad.view.defaultWidgetView = new WidgetView(defaultWidget, 0, false, $scope);
                        }
                    }
                    if (!$scope.ad.view.defaultWidgetView)
                        $scope.ad.view.defaultWidgetView = new WidgetView(null, 0, false, $scope);
                    $scope.ad.view.defaultWidgetView.isDefault = true;
                }
            }
            $scope.loadCategoryDisplay = function (webSiteApp) {
                if (!webSiteApp)
                    webSiteApp = AppData.getAppByCode("webSite");

                if (webSiteApp) {
                    $scope.ad.view.categoryRootView.initWebDisplay();
                    var appAttr = webSiteApp.getAppAttribute("serviceCategoriesDisplay");
                    if (appAttr && appAttr.text && appAttr.text != '') {
                        let serviceCategoriesDisplay = null;
                        try {
                            serviceCategoriesDisplay = JSON.parse(appAttr.text);
                        } catch (e) {
                            console.log('loadCategoryDisplay => JSON.parse error' , e);
                        }

                        if (serviceCategoriesDisplay) {
                            var categoryView;
                            for (var i = 0; i < serviceCategoriesDisplay.length; i++) {
                                categoryView = $scope.getCategoryViewById(serviceCategoriesDisplay[i].id);
                                if (categoryView)
                                    categoryView.displayType = serviceCategoriesDisplay[i].type;
                            }
                        }
                    }
                    $scope.ad.view.productCategoryRootView.initWebDisplay();
                    var appAttr = webSiteApp.getAppAttribute("productCategoriesDisplay");
                    if (appAttr && appAttr.text && appAttr.text != '') {
                        let productCategoriesDisplay = null;
                        try {
                            productCategoriesDisplay = JSON.parse(appAttr.text);
                        } catch (e) {
                            console.log('loadCategoryDisplay productCategoriesDisplay => JSON.parse error' , e);
                        }

                        if (productCategoriesDisplay) {
                            var categoryView;
                            for (var i = 0; i < productCategoriesDisplay.length; i++) {
                                categoryView = $scope.getProductCategoryViewById(productCategoriesDisplay[i].id);
                                if (categoryView)
                                    categoryView.displayType = productCategoriesDisplay[i].type;
                            }
                        }
                    }
                    $scope.ad.view.cureCategoryRootView.initWebDisplay();
                    var appAttr = webSiteApp.getAppAttribute("cureCategoriesDisplay");
                    if (appAttr && appAttr.text && appAttr.text != '') {
                        let cureCategoriesDisplay = null;
                        try {
                            cureCategoriesDisplay = JSON.parse(appAttr.text);
                        } catch (e) {
                            console.log('loadCategoryDisplay cureCategoriesDisplay => JSON.parse error' , e);
                        }

                        if (cureCategoriesDisplay) {
                            var categoryView;
                            for (var i = 0; i < cureCategoriesDisplay.length; i++) {
                                categoryView = $scope.getCureCategoryViewById(cureCategoriesDisplay[i].id);
                                if (categoryView)
                                    categoryView.displayType = cureCategoriesDisplay[i].type;
                            }
                        }
                    }
                    $scope.ad.view.loyaltyCardCategoryRootView.initWebDisplay();
                    var appAttr = webSiteApp.getAppAttribute("loyaltyCardCategoriesDisplay");
                    if (appAttr && appAttr.text && appAttr.text != '') {
                        let loyaltyCardCategoriesDisplay = null;
                        try {
                            loyaltyCardCategoriesDisplay = JSON.parse(appAttr.text);
                        } catch (e) {
                            console.log('loadCategoryDisplay loyaltyCardCategoriesDisplay => JSON.parse error' , e);
                        }

                        if (loyaltyCardCategoriesDisplay) {
                            var categoryView;
                            for (var i = 0; i < loyaltyCardCategoriesDisplay.length; i++) {
                                categoryView = $scope.getLoyaltyCardCategoryViewById(loyaltyCardCategoriesDisplay[i].id);
                                if (categoryView)
                                    categoryView.displayType = loyaltyCardCategoriesDisplay[i].type;
                            }
                        }
                    }


                }
            }
            $scope.loadDesignAttributes = function (webSiteApp) {
                if (!webSiteApp)
                    webSiteApp = AppData.getAppByCode("webSite");

                if (webSiteApp) {
                    $scope.loadAppAttr(webSiteApp, "homeDisplayType");
                    $scope.loadAppAttr(webSiteApp, "globalBgImage");
                    $scope.loadAppAttr(webSiteApp, "globalBgColor");
                    $scope.loadAppAttr(webSiteApp, "globalObjectColor");
                    $scope.loadAppAttr(webSiteApp, "globalFontFamily");
                    $scope.loadAppAttr(webSiteApp, "headerType");
                    $scope.loadAppAttr(webSiteApp, "footerBgColor");
                    $scope.loadAppAttr(webSiteApp, "footerFontColor");

                    if (screen)
                        if (screen.width > 767) //dont slide on mobile
                        {
                            $scope.loadAppAttr(webSiteApp, "globalBgImageUseSlide", "boolean");
                            $scope.loadAppAttr(webSiteApp, "globalBgImageOverlay", "boolean");
                            if ($scope.ad.appAttributes.globalBgImageUseSlide)
                                $scope.initSlides();
                        }
                        else {
                            $scope.ad.view.isOnMobile = true;
                        }

                    $scope.updateCss();


                }
                else {
                    $scope.ad.appAttributes.globalBgColor = null;
                    $scope.ad.appAttributes.globalBgImage = null;
                }
            }
            $scope.loadAdminAttributes = function (webSiteApp) {
                if (!webSiteApp)
                    webSiteApp = AppData.getAppByCode("webSite");

                if (webSiteApp) {
                    $scope.loadAppAttr(webSiteApp, "homeLabel");
                    $scope.loadAppAttr(webSiteApp, "displayAbout", "boolean");
                    $scope.loadAppAttr(webSiteApp, "aboutLabel");
                    $scope.loadAppAttr(webSiteApp, "displayContact", "boolean");
                    if ($scope.ad.appAttributes.displayContact) {
                        $scope.ad.appAttributes.footerTime = false;
                        $scope.ad.appAttributes.footerAddress = false;
                        $scope.ad.appAttributes.footerMap = false;
                        $scope.ad.appAttributes.footerSocial = false;
                    }
                    $scope.loadAppAttr(webSiteApp, "contactLabel");
                    $scope.loadAppAttr(webSiteApp, "displayServices", "boolean");
                    $scope.loadAppAttr(webSiteApp, "servicesLabel");
                    $scope.loadAppAttr(webSiteApp, "servicesProductsLabel");
                    $scope.loadAppAttr(webSiteApp, "servicesCuresLabel");
                    $scope.loadAppAttr(webSiteApp, "displayProducts", "boolean");
                    $scope.loadAppAttr(webSiteApp, "productsLabel");
                    $scope.loadAppAttr(webSiteApp, "displayCures", "boolean");
                    $scope.loadAppAttr(webSiteApp, "curesLabel");
                    $scope.loadAppAttr(webSiteApp, "displayLoyaltyCards", "boolean");
                    $scope.loadAppAttr(webSiteApp, "loyaltyCardsLabel");
                    $scope.loadAppAttr(webSiteApp, "giftsLabel");

                    $scope.loadAppAttr(webSiteApp, "giftItemDeliveryImageId");
                    $scope.loadAppAttr(webSiteApp, "giftItemPrintableImageId");
                    $scope.loadAppAttr(webSiteApp, "giftItemMailImageId");

                    $scope.loadAppAttr(webSiteApp, "homeAbout", "boolean");
                    $scope.loadAppAttr(webSiteApp, "homeAboutSentence");
                    $scope.loadAppAttr(webSiteApp, "homeOffer", "boolean");
                    $scope.loadAppAttr(webSiteApp, "homeOfferSentence");
                    $scope.loadAppAttr(webSiteApp, "homeServiceSentence");
                    $scope.loadAppAttr(webSiteApp, "homeCure", "boolean");
                    $scope.loadAppAttr(webSiteApp, "homeCureSentence");
                    $scope.loadAppAttr(webSiteApp, "homeProduct", "boolean");
                    $scope.loadAppAttr(webSiteApp, "homeProductSentence");
                    $scope.loadAppAttr(webSiteApp, "hasGiftItem", "boolean");
                    $scope.ad.appAttributes.homeService = $scope.ad.appAttributes.displayServices;
                    $scope.loadAppAttr(webSiteApp, "homeService", "boolean");
                    $scope.ad.appAttributes.homeGiftItem = $scope.ad.appAttributes.hasGiftItem;
                    $scope.loadAppAttr(webSiteApp, "homeGiftItem", "boolean");
                    $scope.loadAppAttr(webSiteApp, "homeGiftItemSentence");
                    $scope.loadAppAttr(webSiteApp, "homeLoyaltyCard", "boolean");
                    $scope.loadAppAttr(webSiteApp, "homeLoyaltyCardSentence");
                    $scope.loadAppAttr(webSiteApp, "footerTime", "boolean");
                    $scope.loadAppAttr(webSiteApp, "footerAddress", "boolean");
                    $scope.loadAppAttr(webSiteApp, "footerMap", "boolean");
                    $scope.loadAppAttr(webSiteApp, "footerSocial", "boolean");
                    $scope.loadAppAttr(webSiteApp, "footerFacebook");
                    $scope.loadAppAttr(webSiteApp, "footerTwitter");
                    $scope.loadAppAttr(webSiteApp, "footerInstagram");
                    $scope.loadAppAttr(webSiteApp, "footerPinterest");
                    $scope.loadAppAttr(webSiteApp, "displayFacebook", "boolean");
                    $scope.loadAppAttr(webSiteApp, "autoValidateCustomerPost", "boolean");
                    $scope.loadAppAttr(webSiteApp, "displayCustomerPost", "boolean");
                    $scope.loadAppAttr(webSiteApp, "welcomePictureCustomerPost", "boolean");
                    $scope.loadAppAttr(webSiteApp, "customerPostLabel");

                    $scope.loadAppAttr(webSiteApp, "facebookLabel");
                    $scope.loadAppAttr(webSiteApp, "onlineBooking", "boolean");
                    $scope.loadAppAttr(webSiteApp, "allowChooseHr", "boolean");
                    $scope.loadAppAttr(webSiteApp, "allowBookingComment", "boolean");
                    $scope.loadAppAttr(webSiteApp, "bookingCommentSentence");
                    $scope.loadAppAttr(webSiteApp, "hasBookingPayment", "boolean");
                    $scope.loadAppAttr(webSiteApp, "hasBookingPaymentAdvance", "boolean");
                    $scope.loadAppAttr(webSiteApp, "bookingPaymentAdvancePercent", "int");
                    $scope.loadAppAttr(webSiteApp, "hasBookingPaymentMandatory", "boolean");
                    $scope.loadAppAttr(webSiteApp, "hasBookingPaymentOnAmount", "boolean");
                    $scope.loadAppAttr(webSiteApp, "bookingPaymentOnAmount", "number");
                    $scope.loadAppAttr(webSiteApp, "nbBookingWeeks", "int");
                    $scope.loadAppAttr(webSiteApp, "nbBookingBeforeTime", "int");
                    $scope.loadAppAttr(webSiteApp, "triesTime", "int");
                    $scope.loadAppAttr(webSiteApp, "autoFilling", "boolean");
                    $scope.loadAppAttr(webSiteApp, "hasCurePayment", "boolean");
                    $scope.loadAppAttr(webSiteApp, "hasProductPayment", "boolean");
                    $scope.loadAppAttr(webSiteApp, "hasProductDelivery", "boolean");
                    $scope.loadAppAttr(webSiteApp, "hasProductDeliveryCharge", "boolean");
                    $scope.loadAppAttr(webSiteApp, "productDeliverySentence");
                    $scope.loadAppAttr(webSiteApp, "productDeliveryCharge", "number");
                    $scope.loadAppAttr(webSiteApp, "hasLoyaltyCardPayment", "boolean");
                    $scope.loadAppAttr(webSiteApp, "hasServiceGift", "boolean");
                    $scope.loadAppAttr(webSiteApp, "hasGiftItemDelivery", "boolean");
                    $scope.loadAppAttr(webSiteApp, "giftItemDeliverySentence");
                    $scope.loadAppAttr(webSiteApp, "hasGiftItemDeliveryCharge", "boolean");
                    $scope.loadAppAttr(webSiteApp, "giftItemDeliveryCharge", "number");
                    $scope.loadAppAttr(webSiteApp, "hasGiftItemMail", "boolean");
                    $scope.loadAppAttr(webSiteApp, "googleAnalyticsId");
                    $scope.loadAppAttr(webSiteApp, "javascriptOnHeader", "text");
                    if ($scope.ad.appAttributes.javascriptOnHeader)
                        $scope.ad.appAttributes.javascriptOnHeader = $scope.ad.appAttributes.javascriptOnHeader.replace(/\\\//g, "/");
                    $scope.loadAppAttr(webSiteApp, "javascriptOnBody", "text");
                    if ($scope.ad.appAttributes.javascriptOnBody)
                        $scope.ad.appAttributes.javascriptOnBody = $scope.ad.appAttributes.javascriptOnBody.replace(/\\\//g, "/");


                    let appAttr = webSiteApp.getAppAttribute("giftImageIds");
                    if (appAttr && appAttr.text && appAttr.text !== '') {
                        let giftImageIds = appAttr.text.split(";"),
                            image,
                            imageFromImageData,
                            imageFromCompanyImage;

                        for (var i = 0; i < giftImageIds.length; i++) {
                            imageFromImageData = ImageData.getById(giftImageIds[i]);
                            imageFromCompanyImage = CompanyImageData.getById(giftImageIds[i]);

                            if(imageFromCompanyImage){
                               image = imageFromCompanyImage;
                            }
                            else {
                                image = imageFromImageData;
                            }
                            if (image && $scope.ad.view.imagesGiftView.indexOf(image) === -1)
                                $scope.ad.view.imagesGiftView.push(image);
                        }
                    }
                    else
                        $scope.ad.view.imagesGiftView = $scope.ad.view.imagesServiceView.slice(0);

                    $scope.initFlexyFilteredImagesView();

                    appAttr = webSiteApp.getAppAttribute("discountDays");
                    if (appAttr && appAttr.text && appAttr.text != '') {
                        try {
                            $scope.ad.appAttributes.discountDays = JSON.parse(appAttr.text);
                        } catch (e) {}
                    }
                    $scope.updateCss();


                }
                else {
                    $scope.ad.appAttributes.globalBgColor = null;
                    $scope.ad.appAttributes.globalBgImage = null;
                    $scope.ad.appAttributes.allowChooseHr = false;
                    $scope.ad.appAttributes.allowBookingComment = false;
                }
            };

            $scope.initFlexyFilteredImagesView = function(){
                $scope.ad.view.flexyFilteredImagesView = [];

                for(let i = 0; i < $scope.ad.view.imagesServiceView.length; i++){
                    let imageServiceView = $scope.ad.view.imagesServiceView[i];
                    if(imageServiceView.status === 'NotActivated'){
                        for(let j = 0; j < $scope.ad.view.imagesGiftView.length; j++){
                            if (imageServiceView.id === $scope.ad.view.imagesGiftView[j].id) {
                                $scope.ad.view.flexyFilteredImagesView.push(imageServiceView);
                                break;
                            }
                        }
                    }
                    else {
                        $scope.ad.view.flexyFilteredImagesView.push(imageServiceView);
                    }

                }
            };

            $scope.updateCss = function () {
                let webStyleSheet = null;
                for (let i = 0; i < document.styleSheets.length && !webStyleSheet; i++) {
                    let sheet = document.styleSheets[i];
                    if (sheet.title === 'webSite') {
                        webStyleSheet = sheet;
                    }
                }

                if (webStyleSheet) {
                    if ($scope.ad.appAttributes.globalObjectColorInserted) { //remove 6
                        for (let i = 0; i < 6; i++) {
                            webStyleSheet.deleteRule(webStyleSheet.cssRules.length - 1);
                        }
                    }

                    if ($scope.ad.appAttributes.globalFontFamilyInserted) {
                        for (let i = 0; i < 3; i++) {
                            webStyleSheet.deleteRule(webStyleSheet.cssRules.length - 1);
                        }
                    }

                    if ($scope.ad.appAttributes.globalObjectColor) {
                        webStyleSheet.insertRule("a {text-decoration: none;color: " + $scope.ad.appAttributes.globalObjectColor + " ;cursor: pointer;}", webStyleSheet.cssRules.length);
                        webStyleSheet.insertRule(".no-touch  a:hover,a:focus, a:active {text-decoration: underline;color: " + $scope.ad.appAttributes.globalObjectColor + ";}", webStyleSheet.cssRules.length);
                        webStyleSheet.insertRule(".soft-color {color: " + $scope.ad.appAttributes.globalObjectColor + " ;}", webStyleSheet.cssRules.length);
                        webStyleSheet.insertRule(".button,.no-touch .button:hover,.no-touch .button-booking-active:hover {background: " + $scope.ad.appAttributes.globalObjectColor + " ;}", webStyleSheet.cssRules.length);
                        webStyleSheet.insertRule(".product-specs {color:" + $scope.ad.appAttributes.globalObjectColor + ";}", webStyleSheet.cssRules.length);
                        webStyleSheet.insertRule(".soft-bgcolor {background-color:" + $scope.ad.appAttributes.globalObjectColor + ";}", webStyleSheet.cssRules.length);

                        $scope.ad.appAttributes.globalObjectColorInserted = true;
                    }

                    if ($scope.ad.appAttributes.globalFontFamily) {
                        var font = $scope.getFont($scope.ad.appAttributes.globalFontFamily);
                        if (font) {
                            webStyleSheet.insertRule("body, button, table,.dialog-form .ta-editor {font-family:" + font.css + ";}", webStyleSheet.cssRules.length);
                            webStyleSheet.insertRule("body,.dialog-form .ta-editor {font-size:" + font.size + "%;}", webStyleSheet.cssRules.length);
                            webStyleSheet.insertRule(".nav-primary {padding-top : " + font.padding_top + "px}", webStyleSheet.cssRules.length);

                            $scope.ad.appAttributes.globalFontFamilyInserted = true;
                        }
                    }
                }
            };

            $scope.getFont = function (name) {
                for (var i = 0; i < $scope.ad.view.fontOptions.length; i++)
                    if ($scope.ad.view.fontOptions[i].name == name)
                        return $scope.ad.view.fontOptions[i];
                return null;
            };
            $scope.loadLogo = function (webSiteApp) {
                if (!webSiteApp)
                    webSiteApp = AppData.getAppByCode("webSite");
                if (webSiteApp) {
                    var attribute = webSiteApp.getAppAttribute("logoImageId");
                    if (attribute && attribute.value) {
                        $scope.ad.appAttributes.logoImageId = parseInt(attribute.value);
                        var companyImage = CompanyImageData.getById($scope.ad.appAttributes.logoImageId);
                        if (companyImage) {
                            $scope.ad.view.logoImageUrl = companyImage.urlPreview;
                            $scope.ad.view.logoEditPanelTab = 2;
                        }
                    }
                    $scope.ad.appAttributes.logoText = "<h2>" + $scope.ad.view.siteView.name + "</h2>";
                    $scope.loadAppAttr(webSiteApp, "logoFontColor");
                    $scope.loadAppAttr(webSiteApp, "logoShadowColor");
                    $scope.loadAppAttr(webSiteApp, "logoText");
                }
                else {
                    $scope.ad.appAttributes.logoImageId = null;
                    $scope.ad.appAttributes.logoFontColor = null;
                }
            };

            $scope.loadAppAttributes = function () {
                $scope.loadTemplateAttributes(null, true);
                $scope.loadAdminAttributes();
                $scope.loadCgvHtml();
                $scope.loadHomeTextHtml();
                $scope.loadTemplates();
                $scope.loadGiftItemImages();
            }

            $scope.loadTemplateAttributes = function (webSiteApp, loadSub) {
                $scope.loadLogo(webSiteApp);
                $scope.loadDesignAttributes(webSiteApp);
                $scope.loadMenu(webSiteApp);
                $scope.loadTitle(webSiteApp);
                $scope.loadPosAttributes(webSiteApp);
                $scope.loadWidgetsView(webSiteApp, loadSub);
                $scope.loadCategoryDisplay(webSiteApp);
            }

            $scope.loadTemplates = function () {
                var i = 1;
                this.ad.view.templates = [];
                var webSiteApp = AppData.getAppByCode("webSite-template" + i);
                while (webSiteApp) {
                    var attribute = webSiteApp.getAppAttribute("templateLabel");
                    if (attribute)
                        this.ad.view.templates.push({ id: i, label: attribute.value });
                    i++;
                    webSiteApp = AppData.getAppByCode("webSite-template" + i);
                }
                i = 1;
                this.ad.view.gTemplates = [];
                var webSiteApp = AppData.getAppByCode("webSite-g-template" + i);
                const uselessThemes = Constants.WEBSITE_USELESS_THEME_LABELS;
                while (webSiteApp) {
                    var attribute = webSiteApp.getAppAttribute("templateLabel");
                    if (attribute && attribute.value && uselessThemes.indexOf(attribute.value) === -1) {
                        this.ad.view.gTemplates.push({ id: i, label: attribute.value });
                    }
                    i++;
                    webSiteApp = AppData.getAppByCode("webSite-g-template" + i);
                }
            };
            $scope.loadSelectedTemplate = function (template, isGlobal) {
                if (template) {
                    var webSiteApp = null;
                    if (isGlobal)
                        webSiteApp = AppData.getAppByCode("webSite-g-template" + template.id);
                    else
                        webSiteApp = AppData.getAppByCode("webSite-template" + template.id);
                    if (webSiteApp)
                        $scope.loadTemplateAttributes(webSiteApp, false);//dont load objects from a template
                }
            }
            $scope.initSlides = function () {
                var slides = [];
                for (let i = 0; i < $scope.ad.view.imagesBgCompanyView.length; i++) {
                    let img = $scope.ad.view.imagesBgCompanyView[i];
                    if (img && img.url) {
                        slides.push({ src: img.url });
                    }
                }

                if (!slides.length) {
                    return;
                }

                var elem = $("body");
                if (elem[0]._vegas)
                    elem.vegas('options', 'slides', slides);
                else
                    elem.vegas({
                        delay: 15000,
                        shuffle: true,
                        transition: 'fade',
                        transitionDuration: 3000,
                        timer: false,
                        overlay: $scope.ad.appAttributes.globalBgImageOverlay ? '/lib/vegas/overlays/02.png' : 'none',
                        slides: slides
                    });
            };
            $scope.loadPosAttributes = function () {
                var webPosApp = AppData.getAppByCode("pos");
                if (webPosApp) {
                    var attribute = webPosApp.getAppAttribute("giftMonthValidity");
                    if (attribute) {
                        var giftMonthValidity = parseInt(attribute.value);
                        if (!isNaN(giftMonthValidity))
                            $scope.ad.appAttributes.giftMonthValidity = giftMonthValidity;
                    }
                }
            };
            $scope.addBookingServiceView = function (serviceView) {
                $scope.ad.view.errorMessage = "";
                $scope.ad.view.currentServiceView = serviceView;
                if ($scope.ad.view.currentBookingView == null)
                    $scope.ad.view.currentBookingView = new BookingView(null, -1, $scope);
                var citsView = null;
                if ($scope.ad.view.customerView)
                    citsView = $scope.ad.view.customerView.getFirstCureItemToServiceViewByServiceView(serviceView);
                if (citsView)
                    $scope.addServiceOnBookingOnUserSelectCureItem(citsView);
                else {
                    if ($scope.ad.view.currentSaleView && $scope.ad.view.currentBookingView) {
                        $scope.ad.view.currentBookingView.saleView = $scope.ad.view.currentSaleView;
                        $scope.ad.view.currentSaleView.bookingView = $scope.ad.view.currentBookingView;
                    }
                    $scope.ad.view.currentBookingServiceView = $scope.ad.view.currentBookingView.addServiceOnBooking($scope.ad.view.currentServiceView);

                    $scope.openLocation("cart");
                }

            };
            $scope.addServiceOnBookingOnUserSelectCureItem = function (citsView) {
                let cureItemServices = $scope.setCureItemServices(citsView.cureItemView.cureItemId, citsView.serviceView.serviceId);

                CureItemSrv.checkCureItemServiceIsUsed(cureItemServices, function(data){
                    if(data.cureItemServices && data.cureItemServices.length === 0){
                        if ($scope.ad.view.currentBookingView == null)
                            $scope.ad.view.currentBookingView = new BookingView(null, -1, $scope);
                        if ($scope.ad.view.currentSaleView) {
                            $scope.ad.view.currentBookingView.saleView = $scope.ad.view.currentSaleView;
                            $scope.ad.view.currentSaleView.bookingView = $scope.ad.view.currentBookingView;
                        }
                        $scope.ad.view.currentBookingServiceView = $scope.ad.view.currentBookingView.addServiceOnBookingOnUserSelectCureItem(citsView);
                        $scope.openLocation("cart");
                    }
                    else {
                        $scope.ad.view.cureDisplayError = true;
                    }
               });

            };

            $scope.setCureItemServices = function(cureItemId, serviceId){
                let cureItem = new Object(),
                    cureItemServices = [];

                cureItem.cureItemId = cureItemId;
                cureItem.serviceId = serviceId;
                cureItemServices.push(cureItem);

                return cureItemServices;
            };

            $scope.addSaleProductView = function (productView) {
                $scope.ad.view.currentProductView = productView;
                if ($scope.ad.view.currentSaleView == null) {
                    $scope.ad.view.currentSaleView = new SaleView(null, -1, null, null, $scope.ad.view);
                    $scope.ad.view.currentSaleView.isCreatedByCustomer = true;
                }
                if ($scope.ad.view.currentBookingView) {
                    $scope.ad.view.currentBookingView.saleView = $scope.ad.view.currentSaleView;
                    $scope.ad.view.currentSaleView.bookingView = $scope.ad.view.currentBookingView;
                }

                $scope.ad.view.currentSaleServiceView = $scope.ad.view.currentSaleView.addProductOnSale(productView, null, true);
                $scope.ad.view.currentSaleView.customerView = $scope.ad.view.customerView;
                if ($scope.ad.appAttributes.hasProductDelivery)
                    $scope.ad.view.currentSaleView.setDelivery("address", true, $scope.ad.appAttributes.productDeliveryCharge);
                $scope.openLocation("checkout");
            };
            $scope.addSaleCureView = function (cureView) {
                $scope.ad.view.currentCureView = cureView;
                if ($scope.ad.view.currentSaleView == null) {
                    $scope.ad.view.currentSaleView = new SaleView(null, -1, null, null, $scope.ad.view);
                    $scope.ad.view.currentSaleView.isCreatedByCustomer = true;
                }
                if ($scope.ad.view.currentBookingView) {
                    $scope.ad.view.currentBookingView.saleView = $scope.ad.view.currentSaleView;
                    $scope.ad.view.currentSaleView.bookingView = $scope.ad.view.currentBookingView;
                }

                $scope.ad.view.currentSaleServiceView = $scope.ad.view.currentSaleView.addCureOnSale(cureView, null, true);
                $scope.ad.view.currentSaleView.customerView = $scope.ad.view.customerView;
                $scope.openLocation("checkout");
            };
            $scope.addSaleLoyaltyCardView = function (loyaltyCardView) {
                $scope.ad.view.currentLoyaltyCardView = loyaltyCardView;
                if ($scope.ad.view.currentSaleView == null) {
                    $scope.ad.view.currentSaleView = new SaleView(null, -1, null, null, $scope.ad.view);
                    $scope.ad.view.currentSaleView.isCreatedByCustomer = true;
                }
                else if ($scope.ad.view.currentSaleView.loyaltyCardItemView)
                    return;
                if ($scope.ad.view.currentBookingView) {
                    $scope.ad.view.currentBookingView.saleView = $scope.ad.view.currentSaleView;
                    $scope.ad.view.currentSaleView.bookingView = $scope.ad.view.currentBookingView;

                }

                $scope.ad.view.currentSaleServiceView = $scope.ad.view.currentSaleView.addLoyaltyCardOnSale(loyaltyCardView, null, true);
                $scope.ad.view.currentSaleView.customerView = $scope.ad.view.customerView;
                $scope.openLocation("checkout");
            }

            $scope.saveGiftItemImages = function() {
                let webSiteApp = $scope.computeWebSiteApp();
                $scope.saveAppAttr(webSiteApp, "giftItemDeliveryImageId");
                $scope.saveAppAttr(webSiteApp, "giftItemPrintableImageId");
                $scope.saveAppAttr(webSiteApp, "giftItemMailImageId");
                AppSrv.save(webSiteApp);
            }

            $scope.saveGiftItemDeliveryImage = function(image) {
                $scope.ad.appAttributes.giftItemDeliveryImageId = (image) ? image.id : "";
                $scope.saveGiftItemImages();
                $scope.ad.view.giftItemDeliveryImage = (image) ? image : { urlPreview: "/img/exemplebon_box.svg" };
            }

            $scope.saveGiftItemPrintableImage = function(image) {
                $scope.ad.appAttributes.giftItemPrintableImageId = (image) ? image.id : "";
                $scope.saveGiftItemImages();
                $scope.ad.view.giftItemPrintableImage = (image) ? image : { urlPreview: "/img/exemplebon_print.svg" };
            }

            $scope.saveGiftItemMailImage = function(image) {
                $scope.ad.appAttributes.giftItemMailImageId = (image) ? image.id : "";
                $scope.saveGiftItemImages();
                $scope.ad.view.giftItemMailImage = (image) ? image : { urlPreview: "/img/exemplebon_mail.svg" };
            }

            $scope.loadGiftItemImages = function () {
                let webSiteApp = AppData.getAppByCode("webSite");
                if (webSiteApp) {
                    $scope.ad.view.giftItemDeliveryImage = $scope.loadGiftItemImage(webSiteApp, "giftItemDeliveryImageId");
                    $scope.ad.view.giftItemPrintableImage = $scope.loadGiftItemImage(webSiteApp, "giftItemPrintableImageId");
                    $scope.ad.view.giftItemMailImage = $scope.loadGiftItemImage(webSiteApp, "giftItemMailImageId");
                }
            }

            /**
             * Load image from its id find by the appAttribute code.
             * Search first in the imagesServiceView then if nothing found in the imagesCompanyView.
             *
             * @param {string} webSiteApp
             * @param {string} code
             *
             * @return {object} the image or an object with a default url preview image.
             */
            $scope.loadGiftItemImage = function (webSiteApp, code) {
                let appAttr = webSiteApp.getAppAttribute(code);
                if (appAttr && appAttr.value !== "") {
                    let id = appAttr.value;
                    return $scope.getImagesViewById(id);
                }
                if(code === "giftItemDeliveryImageId"){
                    return { urlPreview: "/img/exemplebon_box.svg", label: "" };
                }
                else if(code === "giftItemPrintableImageId"){
                    return { urlPreview: "/img/exemplebon_print.svg", label: "" };
                }
                else if(code ===  "giftItemMailImageId"){
                    return { urlPreview: "/img/exemplebon_mail.svg", label: "" };
                }
                else{
                    return { urlPreview: "/img/exemplebon.svg", label: "" };
                }
            }

            $scope.addHeadersForMangopay = function () {
                $http.defaults.headers.common.height = window.innerHeight;
                $http.defaults.headers.common.width = window.innerWidth;
                $http.defaults.headers.common.java = navigator.javaEnabled();
                $http.defaults.headers.common.javascript = true;
                $http.defaults.headers.common.language = navigator.language;
                $http.defaults.headers.common.timezoneOffset = (new Date()).getTimezoneOffset();
                $http.defaults.headers.common.colorDepth = screen.colorDepth;
            }


            $scope.loadAdminFunctions = function () {
                if ($scope.ad.tokenAdmin) {
                    $scope.ad.view.gridOptions.disableResize = false;
                    $scope.ad.view.gridOptions.disableDrag = false;

                    $scope.addNewTemplate = function () {
                        $scope.ad.view.cTemplate = { id: $scope.ad.view.templates.length + 1, label: "" };
                    };
                    $scope.saveTemplate = function (template) {
                        if (template) {
                            var webSiteApp = AppData.getAppByCode("webSite-template" + template.id);
                            if (!webSiteApp) {
                                webSiteApp = new App();
                                webSiteApp.setCode("webSite-template" + template.id);
                            }
                            $scope.saveLogo(false, webSiteApp);
                            $scope.saveTitle(false, webSiteApp);
                            $scope.saveMenu(false, webSiteApp);
                            $scope.saveDesignAttributes(false, webSiteApp);
                            $scope.saveWidgets(false, webSiteApp);
                            $scope.saveCategoryDisplay(false, webSiteApp);
                            var appAttr = webSiteApp.getAppAttribute("templateLabel");
                            if (appAttr)
                                appAttr.value = template.label;
                            else
                                webSiteApp.addAppAttribute(new AppAttribute("templateLabel", template.label));
                            $scope.ad.view.templates.push(template);
                            $scope.ad.view.cTemplate = null;

                            AppSrv.save(webSiteApp);
                        }
                    };
                    $scope.removeTemplate = function (template) {
                        var index = $scope.ad.view.templates.indexOf(template);
                        if (index != -1) {
                            var webSiteApp = AppData.getAppByCode("webSite-template" + template.id);
                            if (webSiteApp)
                                AppSrv.remove(webSiteApp);
                            var i = template.id + 1;
                            while (i <= $scope.ad.view.templates.length) {
                                webSiteApp = AppData.getAppByCode("webSite-template" + i);
                                if (webSiteApp) {
                                    webSiteApp.code = "webSite-template" + (i - 1);
                                    AppSrv.save(webSiteApp);
                                }
                                i++;
                            }
                            $scope.ad.view.templates.splice(index, 1);
                        }
                    }
                    $scope.removeLogoImage = function () {
                        $scope.ad.appAttributes.logoImageId = null;
                        $scope.ad.view.logoImageUrl = null;
                    };
                    $scope.saveLogo = function (save, webSiteApp) {
                        $scope.ad.view.logoEditPanel = false;

                        webSiteApp = $scope.computeWebSiteApp();
                        $scope.saveAppAttr(webSiteApp, "logoFontColor");
                        $scope.saveAppAttr(webSiteApp, "logoShadowColor");
                        $scope.saveAppAttr(webSiteApp, "logoText");
                        $scope.saveAppAttr(webSiteApp, "logoImageId");
                        if (save)
                            AppSrv.save(webSiteApp);
                    };

                    $scope.saveTitle = function (save, webSiteApp) {
                        webSiteApp = $scope.computeWebSiteApp();

                        var appAttr = webSiteApp.getAppAttribute("titleIsDisplayed");
                        if (appAttr)
                            appAttr.value = $scope.ad.appAttributes.titleIsDisplayed ? "true" : "false";
                        else
                            webSiteApp.addAppAttribute(new AppAttribute("titleIsDisplayed", $scope.ad.appAttributes.titleIsDisplayed));
                        appAttr = webSiteApp.getAppAttribute("titleHomeLabel");
                        if (appAttr)
                            appAttr.value = $scope.ad.appAttributes.titleHomeLabel;
                        else
                            webSiteApp.addAppAttribute(new AppAttribute("titleHomeLabel", $scope.ad.appAttributes.titleHomeLabel));
                        appAttr = webSiteApp.getAppAttribute("titleBgColorStart");
                        if (appAttr)
                            appAttr.value = $scope.ad.appAttributes.titleBgColorStart;
                        else
                            webSiteApp.addAppAttribute(new AppAttribute("titleBgColorStart", $scope.ad.appAttributes.titleBgColorStart));
                        appAttr = webSiteApp.getAppAttribute("titleBgColorEnd");
                        if (appAttr)
                            appAttr.value = $scope.ad.appAttributes.titleBgColorEnd;
                        else
                            webSiteApp.addAppAttribute(new AppAttribute("titleBgColorEnd", $scope.ad.appAttributes.titleBgColorEnd));
                        appAttr = webSiteApp.getAppAttribute("titleFontColor");
                        if (appAttr)
                            appAttr.value = $scope.ad.appAttributes.titleFontColor;
                        else
                            webSiteApp.addAppAttribute(new AppAttribute("titleFontColor", $scope.ad.appAttributes.titleFontColor));
                        $scope.ad.view.titleEditPanel = false;
                        if (save)
                            AppSrv.save(webSiteApp);
                    };
                    $scope.saveHomeTextHtml = function () {
                        let webSiteApp = $scope.computeWebSiteApp();
                        var appAttr = webSiteApp.getAppAttribute("homeTextHtml");
                        if (!appAttr) {
                            appAttr = new AppAttribute("homeTextHtml", "");
                            appAttr.text = $scope.ad.appAttributes.homeTextHtml;
                            webSiteApp.addAppAttribute(appAttr);
                        }
                        else
                            appAttr.text = $scope.ad.appAttributes.homeTextHtml;

                        $scope.ad.view.homeTextEditPanel = false;
                        AppSrv.save(webSiteApp);
                    };
                    $scope.saveWidgets = function (save, webSiteApp) {
                        webSiteApp = $scope.computeWebSiteApp();
                        var appAttr;
                        if ($scope.ad.view.homeWidgetView) {
                            appAttr = webSiteApp.getAppAttribute("homeWidget");
                            if (!appAttr) {
                                appAttr = new AppAttribute("homeWidget", null);
                                webSiteApp.simpleAddAppAttribute(appAttr);
                            }
                            else // manage removing
                                if (appAttr.text && appAttr.text != '') {
                                    let homeWidget = null;
                                    try {
                                        homeWidget = JSON.parse(appAttr.text);
                                    } catch (e) {}

                                    if (homeWidget) {
                                        var inside;
                                        for (var i = 0; i < homeWidget.widgets.length; i++)
                                            if (homeWidget.widgets[i].type == 'object' && homeWidget.widgets[i].objectId) {
                                                inside = false;
                                                for (var j = 0; j < $scope.ad.view.homeWidgetView.widgetsView.length; j++)
                                                    if ($scope.ad.view.homeWidgetView.widgetsView[j].type == 'object' && $scope.ad.view.homeWidgetView.widgetsView[j].object && typeof $scope.ad.view.homeWidgetView.widgetsView[j].object.getModel == 'function') {
                                                        var obj = $scope.ad.view.homeWidgetView.widgetsView[j].object.getModel();
                                                        if (obj && obj.id == homeWidget.widgets[i].objectId)
                                                            inside = true;
                                                    }
                                                if (!inside)//removed
                                                {
                                                    var objectView = null;
                                                    switch (homeWidget.widgets[i].objectType) {
                                                        case "service":
                                                            objectView = $scope.getServiceViewById(homeWidget.widgets[i].objectId);
                                                            break;
                                                        case "product":
                                                            objectView = $scope.getProductViewById(homeWidget.widgets[i].objectId);
                                                            break;
                                                        case "cure":
                                                            objectView = $scope.getCureViewById(homeWidget.widgets[i].objectId);
                                                            break;
                                                    }
                                                    if (objectView) {
                                                        var obj = objectView.getModel();
                                                        if (obj && obj.isOnHome) {
                                                            objectView.isOnHome = false;
                                                            if (homeWidget.widgets[i].objectType == "product")
                                                                objectView.updateModel(true);//dont update quantity
                                                            else
                                                                objectView.updateModel();
                                                        }

                                                    }

                                                }
                                            }
                                    }
                                }


                            appAttr.text = JSON.stringify($scope.ad.view.homeWidgetView.getObjectResource());
                            // Manage value isOnHome
                            for (var i = 0; i < $scope.ad.view.homeWidgetView.widgetsView.length; i++)
                                if ($scope.ad.view.homeWidgetView.widgetsView[i].type == 'object' && $scope.ad.view.homeWidgetView.widgetsView[i].object)
                                    switch ($scope.ad.view.homeWidgetView.widgetsView[i].objectType) {
                                        case "service":
                                        case "cure":
                                        case "loyaltyCard":
                                            var obj = $scope.ad.view.homeWidgetView.widgetsView[i].object.getModel();
                                            if (obj && !obj.isOnHome) {
                                                $scope.ad.view.homeWidgetView.widgetsView[i].object.isOnHome = true;
                                                $scope.ad.view.homeWidgetView.widgetsView[i].object.updateModel();
                                            }
                                            break;
                                        case "product":
                                            var obj = $scope.ad.view.homeWidgetView.widgetsView[i].object.getModel();
                                            if (obj && !obj.isOnHome) {
                                                $scope.ad.view.homeWidgetView.widgetsView[i].object.isOnHome = true;
                                                $scope.ad.view.homeWidgetView.widgetsView[i].object.updateModel(true);//dont update quantity
                                            }
                                            break;
                                    }
                        }
                        //homeGridWidgets
                        if ($scope.ad.view.homeGridWidgetsView) {
                            appAttr = webSiteApp.getAppAttribute("homeGridWidgets");
                            if (!appAttr) {
                                appAttr = new AppAttribute("homeGridWidgets", null);
                                webSiteApp.simpleAddAppAttribute(appAttr);
                            }
                            var widgets = [];
                            for (var i = 0; i < $scope.ad.view.homeGridWidgetsView.length; i++) {
                                widgets.push($scope.ad.view.homeGridWidgetsView[i].getObjectResource());
                            }
                            appAttr.text = JSON.stringify(widgets);
                        }

                        if (save)
                            AppSrv.save(webSiteApp);


                    }
                    $scope.saveCategoryDisplay = function (save, webSiteApp) {
                        webSiteApp = $scope.computeWebSiteApp();
                        var appAttr = null;
                        var array = [];
                        if ($scope.ad.view.categoryRootView) {
                            appAttr = webSiteApp.getAppAttribute("serviceCategoriesDisplay");
                            if (!appAttr) {
                                appAttr = new AppAttribute("serviceCategoriesDisplay", null);
                                webSiteApp.simpleAddAppAttribute(appAttr);
                            }
                            $scope.ad.view.categoryRootView.populateDisplayTypeResource(array);
                            appAttr.text = JSON.stringify(array);
                        }
                        if ($scope.ad.view.productCategoryRootView) {
                            appAttr = webSiteApp.getAppAttribute("productCategoriesDisplay");
                            if (!appAttr) {
                                appAttr = new AppAttribute("productCategoriesDisplay", null);
                                webSiteApp.simpleAddAppAttribute(appAttr);
                            }
                            array = [];
                            $scope.ad.view.productCategoryRootView.populateDisplayTypeResource(array);
                            appAttr.text = JSON.stringify(array);
                        }
                        if ($scope.ad.view.cureCategoryRootView) {
                            appAttr = webSiteApp.getAppAttribute("cureCategoriesDisplay");
                            if (!appAttr) {
                                appAttr = new AppAttribute("cureCategoriesDisplay", null);
                                webSiteApp.simpleAddAppAttribute(appAttr);
                            }
                            array = [];
                            $scope.ad.view.cureCategoryRootView.populateDisplayTypeResource(array);
                            appAttr.text = JSON.stringify(array);
                        }
                        if ($scope.ad.view.loyaltyCardCategoryRootView) {
                            appAttr = webSiteApp.getAppAttribute("loyaltyCardCategoriesDisplay");
                            if (!appAttr) {
                                appAttr = new AppAttribute("loyaltyCardCategoriesDisplay", null);
                                webSiteApp.simpleAddAppAttribute(appAttr);
                            }
                            array = [];
                            $scope.ad.view.loyaltyCardCategoryRootView.populateDisplayTypeResource(array);
                            appAttr.text = JSON.stringify(array);
                        }
                        if (save)
                            AppSrv.save(webSiteApp);


                    };

                    $scope.saveAll = function (save, webSiteApp) {
                        $scope.saveLogo(false, webSiteApp);
                        $scope.saveTitle(false, webSiteApp);
                        $scope.saveMenu(false, webSiteApp);
                        $scope.saveDesignAttributes(false, webSiteApp);
                        $scope.saveWidgets(false, webSiteApp);
                        $scope.saveCategoryDisplay(false, webSiteApp);
                        $scope.saveAdminAttributes(true, webSiteApp);
                        $scope.saveGiftItemImages();
                    }

                    $scope.saveMenu = function (save, webSiteApp) {
                        webSiteApp = $scope.computeWebSiteApp();
                        var appAttr = webSiteApp.getAppAttribute("menuIsDisplayed");
                        if (appAttr)
                            appAttr.value = $scope.ad.appAttributes.menuIsDisplayed ? "true" : "false";
                        else
                            webSiteApp.addAppAttribute(new AppAttribute("menuIsDisplayed", $scope.ad.appAttributes.menuIsDisplayed));
                        appAttr = webSiteApp.getAppAttribute("menuBgColorStart");
                        if (appAttr)
                            appAttr.value = $scope.ad.appAttributes.menuBgColorStart;
                        else
                            webSiteApp.addAppAttribute(new AppAttribute("menuBgColorStart", $scope.ad.appAttributes.menuBgColorStart));
                        appAttr = webSiteApp.getAppAttribute("menuBgColorEnd");
                        if (appAttr)
                            appAttr.value = $scope.ad.appAttributes.menuBgColorEnd;
                        else
                            webSiteApp.addAppAttribute(new AppAttribute("menuBgColorEnd", $scope.ad.appAttributes.menuBgColorEnd));
                        appAttr = webSiteApp.getAppAttribute("menuFontColor");
                        if (appAttr)
                            appAttr.value = $scope.ad.appAttributes.menuFontColor;
                        else
                            webSiteApp.addAppAttribute(new AppAttribute("menuFontColor", $scope.ad.appAttributes.menuFontColor));
                        appAttr = webSiteApp.getAppAttribute("menuShadowColor");
                        if (appAttr)
                            appAttr.value = $scope.ad.appAttributes.menuShadowColor;
                        else
                            webSiteApp.addAppAttribute(new AppAttribute("menuShadowColor", $scope.ad.appAttributes.menuShadowColor));
                        $scope.ad.view.menuEditPanel = false;
                        if (save)
                            AppSrv.save(webSiteApp);
                    };

                    $scope.saveDesignAttributes = function (save, webSiteApp) {
                        webSiteApp = $scope.computeWebSiteApp();
                        $scope.saveAppAttr(webSiteApp, "homeDisplayType");
                        $scope.saveAppAttr(webSiteApp, "globalBgImage");
                        $scope.saveAppAttr(webSiteApp, "globalBgColor");
                        $scope.saveAppAttr(webSiteApp, "globalObjectColor");
                        $scope.saveAppAttr(webSiteApp, "headerType");
                        $scope.saveAppAttr(webSiteApp, "globalFontFamily");
                        $scope.saveAppAttr(webSiteApp, "globalBgImageUseSlide");
                        $scope.saveAppAttr(webSiteApp, "globalBgImageOverlay");
                        $scope.saveAppAttr(webSiteApp, "footerBgColor");
                        $scope.saveAppAttr(webSiteApp, "footerFontColor");
                    }

                    $scope.saveAdminAttributes = function (save, webSiteApp) {
                        webSiteApp = $scope.computeWebSiteApp();
                        $scope.saveAppAttr(webSiteApp, "homeLabel");
                        $scope.saveAppAttr(webSiteApp, "displayAbout");
                        $scope.saveAppAttr(webSiteApp, "aboutLabel");
                        $scope.saveAppAttr(webSiteApp, "displayContact");
                        $scope.saveAppAttr(webSiteApp, "contactLabel");
                        $scope.saveAppAttr(webSiteApp, "displayServices");
                        $scope.saveAppAttr(webSiteApp, "servicesLabel");
                        $scope.saveAppAttr(webSiteApp, "servicesProductsLabel");
                        $scope.saveAppAttr(webSiteApp, "servicesCuresLabel");
                        $scope.saveAppAttr(webSiteApp, "displayProducts");
                        $scope.saveAppAttr(webSiteApp, "productsLabel");
                        $scope.saveAppAttr(webSiteApp, "displayCures");
                        $scope.saveAppAttr(webSiteApp, "curesLabel");
                        $scope.saveAppAttr(webSiteApp, "displayLoyaltyCards");
                        $scope.saveAppAttr(webSiteApp, "loyaltyCardsLabel");
                        $scope.saveAppAttr(webSiteApp, "giftsLabel");
                        $scope.saveAppAttr(webSiteApp, "hasGiftItem");

                        $scope.saveAppAttr(webSiteApp, "homeAbout");
                        $scope.saveAppAttr(webSiteApp, "homeAboutSentence");
                        $scope.saveAppAttr(webSiteApp, "homeOffer");
                        $scope.saveAppAttr(webSiteApp, "homeOfferSentence");
                        $scope.saveAppAttr(webSiteApp, "homeService");
                        $scope.saveAppAttr(webSiteApp, "homeServiceSentence");
                        $scope.saveAppAttr(webSiteApp, "homeCure");
                        $scope.saveAppAttr(webSiteApp, "homeCureSentence");
                        $scope.saveAppAttr(webSiteApp, "homeProduct");
                        $scope.saveAppAttr(webSiteApp, "homeProductSentence");
                        $scope.saveAppAttr(webSiteApp, "homeGiftItem");
                        $scope.saveAppAttr(webSiteApp, "homeGiftItemSentence");
                        $scope.saveAppAttr(webSiteApp, "homeLoyaltyCard");
                        $scope.saveAppAttr(webSiteApp, "homeLoyaltyCardSentence");
                        $scope.saveAppAttr(webSiteApp, "footerTime");
                        $scope.saveAppAttr(webSiteApp, "footerAddress");
                        $scope.saveAppAttr(webSiteApp, "footerMap");
                        $scope.saveAppAttr(webSiteApp, "footerSocial");
                        $scope.saveAppAttr(webSiteApp, "footerFacebook");
                        $scope.saveAppAttr(webSiteApp, "footerTwitter");
                        $scope.saveAppAttr(webSiteApp, "footerInstagram");
                        $scope.saveAppAttr(webSiteApp, "footerPinterest");
                        $scope.saveAppAttr(webSiteApp, "displayFacebook");
                        $scope.saveAppAttr(webSiteApp, "autoValidateCustomerPost");
                        $scope.saveAppAttr(webSiteApp, "displayCustomerPost");
                        $scope.saveAppAttr(webSiteApp, "welcomePictureCustomerPost");
                        $scope.saveAppAttr(webSiteApp, "customerPostLabel");
                        $scope.saveAppAttr(webSiteApp, "facebookLabel");
                        $scope.saveAppAttr(webSiteApp, "onlineBooking");
                        $scope.saveAppAttr(webSiteApp, "allowChooseHr");
                        $scope.saveAppAttr(webSiteApp, "allowBookingComment");
                        $scope.saveAppAttr(webSiteApp, "bookingCommentSentence");
                        $scope.saveAppAttr(webSiteApp, "hasBookingPayment");
                        $scope.saveAppAttr(webSiteApp, "hasBookingPaymentAdvance");
                        $scope.saveAppAttr(webSiteApp, "bookingPaymentAdvancePercent");
                        $scope.saveAppAttr(webSiteApp, "hasBookingPaymentMandatory");
                        $scope.saveAppAttr(webSiteApp, "hasBookingPaymentOnAmount");
                        $scope.saveAppAttr(webSiteApp, "bookingPaymentOnAmount");
                        $scope.saveAppAttr(webSiteApp, "nbBookingWeeks");
                        $scope.saveAppAttr(webSiteApp, "nbBookingBeforeTime");
                        $scope.saveAppAttr(webSiteApp, "triesTime");
                        $scope.saveAppAttr(webSiteApp, "autoFilling");
                        $scope.saveAppAttr(webSiteApp, "hasCurePayment");
                        $scope.saveAppAttr(webSiteApp, "hasProductPayment");
                        $scope.saveAppAttr(webSiteApp, "hasProductDelivery");
                        $scope.saveAppAttr(webSiteApp, "hasProductDeliveryCharge");
                        $scope.saveAppAttr(webSiteApp, "productDeliverySentence");
                        $scope.saveAppAttr(webSiteApp, "productDeliveryCharge");
                        $scope.saveAppAttr(webSiteApp, "hasLoyaltyCardPayment");
                        $scope.saveAppAttr(webSiteApp, "hasServiceGift");
                        $scope.saveAppAttr(webSiteApp, "hasGiftItemDelivery");
                        $scope.saveAppAttr(webSiteApp, "giftItemDeliverySentence");
                        $scope.saveAppAttr(webSiteApp, "hasGiftItemDeliveryCharge");
                        $scope.saveAppAttr(webSiteApp, "giftItemDeliveryCharge");
                        $scope.saveAppAttr(webSiteApp, "hasGiftItemMail");
                        $scope.saveAppAttr(webSiteApp, "googleAnalyticsId");
                        $scope.saveAppAttr(webSiteApp, "javascriptOnHeader", true);
                        $scope.saveAppAttr(webSiteApp, "javascriptOnBody", true);

                        if (!OfferManager.hasAccessToFeature($scope.ad.subscriptions, StoreAppCode.OPTION_WEBSITE_PAYMENT)) {
                            $scope.ad.appAttributes.displayProducts = false;
                            $scope.ad.appAttributes.displayCures = false;
                            $scope.ad.appAttributes.displayLoyaltyCards = false;
                            $scope.ad.appAttributes.homeCure = false;
                            $scope.ad.appAttributes.homeProduct = false;
                            $scope.ad.appAttributes.homeGiftItem = false;
                            $scope.ad.appAttributes.homeLoyaltyCard = false;
                        }
                        // SPECIFIC FIELDS
                        var images = ImageData.getActiveList("");
                        var appAttr = webSiteApp.getAppAttribute("giftImageIds");
                        if ($scope.ad.view.imagesGiftView.length != images.length || appAttr)//set only if specific
                        {
                            var giftImageIds = "";
                            for (var i = 0; i < $scope.ad.view.imagesGiftView.length; i++) {

                                giftImageIds = giftImageIds + $scope.ad.view.imagesGiftView[i].id
                                if ((i + 1) < $scope.ad.view.imagesGiftView.length)
                                    giftImageIds = giftImageIds + ";"
                            }

                            if (!appAttr) {
                                appAttr = new AppAttribute("giftImageIds", null);
                                webSiteApp.simpleAddAppAttribute(appAttr);
                            }
                            appAttr.text = giftImageIds;

                        }
                        if ($scope.ad.view.aTableView) {
                            console.log("discountDays");
                            console.log($scope.ad.appAttributes.discountDays);

                            appAttr = webSiteApp.getAppAttribute("discountDays");
                            if (!appAttr) {
                                appAttr = new AppAttribute("discountDays", null);
                                webSiteApp.simpleAddAppAttribute(appAttr);
                            }
                            appAttr.text = JSON.stringify($scope.ad.appAttributes.discountDays);
                            console.log(appAttr);
                        }


                        if (save) {
                            if ($scope.ad.view.adminEditPanelTab == 1 && $scope.ad.view.adminEditPanelDesignTab == 1 && $scope.ad.view.adminEditPanelDesignBgTab == 2) {
                                AppSrv.save(webSiteApp, function () {
                                    $timeout(function () {
                                        parent.location.reload();
                                    }, 1000);
                                });
                            }
                            else {
                                AppSrv.save(webSiteApp, function () {
                                    $scope.reloadLocation();
                                });

                            }
                            $scope.toggleAdmin();

                        }

                    }
                    $scope.generateHomeGrids = function () {
                        var question = gettextCatalog.getString("Souhaitez vous effacer la page et générer automatiquement les éléments ");

                        var opts = {
                            backdrop: true,
                            keyboard: true,
                            backdropClick: false,
                            templateUrl: '/partials/global/generalConfirm.html',
                            controller: 'DialogCtrl',
                            resolve: {
                                dialogsModel: function () {
                                    var tableModel = [];
                                        tableModel["question"] = question+"?";
                                    return tableModel;
                                }
                            }
                        };

                        var d = $dialog.dialog(opts);
                        d.open().then(function (result) {
                            if (result) {


                                var widgetView;
                                var x = 0;
                                var y = 0;
                                $scope.ad.view.homeGridWidgetsView = [];
                                if ($scope.ad.view.categoryRootView.categoriesView.length != 0 || $scope.ad.view.categoryRootView.servicesView.length != 0) {
                                    widgetView = new WidgetView(null, $scope.ad.view.homeGridWidgetsView.length, false, $scope);
                                    widgetView.setType('title', true);
                                    widgetView.widgetsView[0].textHtml = "<h1 style=\"text-align:center\">" + $scope.ad.appAttributes.homeServiceSentence + "</h1>";
                                    widgetView.width = 12;
                                    widgetView.height = 2;
                                    widgetView.x = 0;
                                    widgetView.y = y;
                                    widgetView.effect = null;
                                    widgetView.fontColor = "black";
                                    y += 2;
                                    $scope.ad.view.homeGridWidgetsView.push(widgetView);
                                    for (var i = 0; i < $scope.ad.view.categoryRootView.categoriesView.length; i++) {
                                        widgetView = new WidgetView(null, $scope.ad.view.homeGridWidgetsView.length, false, $scope);
                                        widgetView.setObject($scope.ad.view.categoryRootView.categoriesView[i], "category", true);
                                        if (x == 12) {
                                            x = 0;
                                            y += widgetView.height;
                                        }
                                        widgetView.x = x;
                                        x = x + 4;
                                        widgetView.y = y;
                                        $scope.ad.view.homeGridWidgetsView.push(widgetView);
                                    }
                                    for (var i = 0; i < $scope.ad.view.categoryRootView.servicesView.length; i++) {
                                        widgetView = new WidgetView(null, $scope.ad.view.homeGridWidgetsView.length, false, $scope);
                                        widgetView.setObject($scope.ad.view.categoryRootView.servicesView[i], "service", true)
                                        if (x == 12) {
                                            x = 0;
                                            y += widgetView.height;
                                        }
                                        widgetView.x = x;
                                        x = x + 4;
                                        widgetView.y = y;
                                        $scope.ad.view.homeGridWidgetsView.push(widgetView);
                                    }

                                    y += widgetView.height;
                                }
                                x = 0;
                                if ($scope.ad.view.cureCategoryRootView.categoriesView.length != 0 || $scope.ad.view.cureCategoryRootView.curesView.length != 0) {
                                    widgetView = new WidgetView(null, $scope.ad.view.homeGridWidgetsView.length, false, $scope);
                                    widgetView.setType('title', true);
                                    widgetView.widgetsView[0].textHtml = "<h1 style=\"text-align:center\">" + $scope.ad.appAttributes.homeCureSentence + "</h1>";
                                    widgetView.width = 12;
                                    widgetView.height = 2;
                                    widgetView.x = 0;
                                    widgetView.y = y;
                                    y += 2;
                                    widgetView.effect = null;
                                    widgetView.fontColor = "black";
                                    $scope.ad.view.homeGridWidgetsView.push(widgetView);

                                    for (var i = 0; i < $scope.ad.view.cureCategoryRootView.categoriesView.length; i++) {
                                        widgetView = new WidgetView(null, $scope.ad.view.homeGridWidgetsView.length, false, $scope);
                                        widgetView.setObject($scope.ad.view.cureCategoryRootView.categoriesView[i], "cureCategory", true)
                                        if (x == 12) {
                                            x = 0;
                                            y += widgetView.height;
                                        }
                                        widgetView.x = x;
                                        x = x + 4;
                                        widgetView.y = y;
                                        $scope.ad.view.homeGridWidgetsView.push(widgetView);
                                    }
                                    for (var i = 0; i < $scope.ad.view.cureCategoryRootView.curesView.length; i++) {
                                        widgetView = new WidgetView(null, $scope.ad.view.homeGridWidgetsView.length, false, $scope);
                                        widgetView.setObject($scope.ad.view.cureCategoryRootView.curesView[i], "cure", true)
                                        if (x == 12) {
                                            x = 0;
                                            y += widgetView.height;
                                        }
                                        widgetView.x = x;
                                        x = x + 4;
                                        widgetView.y = y;
                                        $scope.ad.view.homeGridWidgetsView.push(widgetView);
                                    }
                                    y += widgetView.height;
                                }
                                if ($scope.ad.view.productCategoryRootView.categoriesView.length != 0 || $scope.ad.view.productCategoryRootView.productsView.length != 0) {
                                    x = 0;
                                    widgetView = new WidgetView(null, $scope.ad.view.homeGridWidgetsView.length, false, $scope);
                                    widgetView.setType('title', true);
                                    widgetView.widgetsView[0].textHtml = "<h1 style=\"text-align:center\">" + $scope.ad.appAttributes.homeProductSentence + "</h1>";
                                    widgetView.width = 12;
                                    widgetView.height = 2;
                                    widgetView.x = 0;
                                    widgetView.y = y;
                                    y += 2;
                                    widgetView.effect = null;
                                    widgetView.fontColor = "black";
                                    $scope.ad.view.homeGridWidgetsView.push(widgetView);

                                    for (var i = 0; i < $scope.ad.view.productCategoryRootView.categoriesView.length; i++) {
                                        widgetView = new WidgetView(null, $scope.ad.view.homeGridWidgetsView.length, false, $scope);
                                        widgetView.setObject($scope.ad.view.productCategoryRootView.categoriesView[i], "productCategory", true)
                                        if (x == 12) {
                                            x = 0;
                                            y += widgetView.height;
                                        }
                                        widgetView.x = x;
                                        x = x + 4;
                                        widgetView.y = y;
                                        $scope.ad.view.homeGridWidgetsView.push(widgetView);
                                    }
                                    for (var i = 0; i < $scope.ad.view.productCategoryRootView.productsView.length; i++) {
                                        widgetView = new WidgetView(null, $scope.ad.view.homeGridWidgetsView.length, false, $scope);
                                        widgetView.setObject($scope.ad.view.productCategoryRootView.productsView[i], "product", true)
                                        if (x == 12) {
                                            x = 0;
                                            y += widgetView.height;
                                        }
                                        widgetView.x = x;
                                        x = x + 4;
                                        widgetView.y = y;
                                        $scope.ad.view.homeGridWidgetsView.push(widgetView);
                                    }
                                    y += widgetView.height;
                                }
                                x = 0;
                                if ($scope.ad.appAttributes.hasGiftItem) {
                                    widgetView = new WidgetView(null, $scope.ad.view.homeGridWidgetsView.length, false, $scope);
                                    widgetView.setType('title', true);
                                    widgetView.widgetsView[0].textHtml = "<h1 style=\"text-align:center\">" + $scope.ad.appAttributes.homeGiftItemSentence + "</h1>";
                                    widgetView.width = 12;
                                    widgetView.height = 2;
                                    widgetView.x = 0;
                                    widgetView.y = y;
                                    y += 2
                                    widgetView.effect = null;
                                    widgetView.fontColor = "black";
                                    ;

                                    $scope.ad.view.homeGridWidgetsView.push(widgetView);

                                    widgetView = new WidgetView(null, $scope.ad.view.homeGridWidgetsView.length, false, $scope);
                                    widgetView.setObject("delivery", "gift", true);
                                    widgetView.fontColor = "black";
                                    widgetView.shadowColor = "white";
                                    widgetView.x = x;
                                    x = x + 4;
                                    widgetView.y = y;
                                    $scope.ad.view.homeGridWidgetsView.push(widgetView);

                                    widgetView = new WidgetView(null, $scope.ad.view.homeGridWidgetsView.length, false, $scope);
                                    widgetView.setObject("mailPrint", "gift", true);
                                    widgetView.x = x;
                                    widgetView.fontColor = "black";
                                    widgetView.shadowColor = "white";

                                    x = x + 4;
                                    widgetView.y = y;
                                    $scope.ad.view.homeGridWidgetsView.push(widgetView);

                                    widgetView = new WidgetView(null, $scope.ad.view.homeGridWidgetsView.length, false, $scope);
                                    widgetView.setObject("mail", "gift", true);
                                    widgetView.x = x;
                                    widgetView.fontColor = "black";
                                    widgetView.shadowColor = "white";

                                    x = x + 4;
                                    widgetView.y = y;
                                    $scope.ad.view.homeGridWidgetsView.push(widgetView);

                                    y += widgetView.height;
                                }
                                if ($scope.ad.view.loyaltyCardCategoryRootView.categoriesView.length != 0 || $scope.ad.view.loyaltyCardCategoryRootView.loyaltyCardsView.length != 0) {
                                    x = 0;
                                    widgetView = new WidgetView(null, $scope.ad.view.homeGridWidgetsView.length, false, $scope);
                                    widgetView.setType('title', true);
                                    widgetView.widgetsView[0].textHtml = "<h1 style=\"text-align:center\">" + $scope.ad.appAttributes.homeLoyaltyCardSentence + "</h1>";
                                    widgetView.width = 12;
                                    widgetView.height = 2;
                                    widgetView.x = 0;
                                    widgetView.y = y;
                                    y += 2;
                                    widgetView.effect = null;
                                    widgetView.fontColor = "black";
                                    $scope.ad.view.homeGridWidgetsView.push(widgetView);

                                    for (var i = 0; i < $scope.ad.view.loyaltyCardCategoryRootView.categoriesView.length; i++) {
                                        widgetView = new WidgetView(null, $scope.ad.view.homeGridWidgetsView.length, false, $scope);
                                        widgetView.setObject($scope.ad.view.loyaltyCardCategoryRootView.categoriesView[i], "loyaltyCardCategory", true);
                                        if (x == 12) {
                                            x = 0;
                                            y += widgetView.height;
                                        }
                                        widgetView.x = x;
                                        x = x + 4;
                                        widgetView.y = y;
                                        $scope.ad.view.homeGridWidgetsView.push(widgetView);
                                    }
                                    for (var i = 0; i < $scope.ad.view.loyaltyCardCategoryRootView.loyaltyCardsView.length; i++) {
                                        widgetView = new WidgetView(null, $scope.ad.view.homeGridWidgetsView.length, false, $scope);
                                        widgetView.setObject($scope.ad.view.loyaltyCardCategoryRootView.loyaltyCardsView[i], "loyaltyCard", true);
                                        if (x == 12) {
                                            x = 0;
                                            y += widgetView.height;
                                        }
                                        widgetView.x = x;
                                        x = x + 4;
                                        widgetView.y = y;
                                        $scope.ad.view.homeGridWidgetsView.push(widgetView);
                                    }
                                }
                            }

                        });
                    }

                    $scope.saveAppAttr = function (webSiteApp, appAttrCode, isText) {
                        if ($scope.ad.appAttributes[appAttrCode] !== undefined) {
                            var appAttr = webSiteApp.getAppAttribute(appAttrCode);
                            var value;
                            if (typeof $scope.ad.appAttributes[appAttrCode] === "boolean")
                                value = $scope.ad.appAttributes[appAttrCode] ? "true" : "false";
                            else if (typeof $scope.ad.appAttributes[appAttrCode] === "number")
                                value = $scope.ad.appAttributes[appAttrCode].toString();
                            else
                                value = $scope.ad.appAttributes[appAttrCode];

                            if (!appAttr) {
                                appAttr = new AppAttribute(appAttrCode, null);
                                webSiteApp.simpleAddAppAttribute(appAttr);
                            }

                            if (isText !== undefined && isText)
                                appAttr.text = value;
                            else
                                appAttr.value = value;

                        }
                    }

                    $scope.toggleAdmin = function () {
                        $scope.ad.adminEdition = !$scope.ad.adminEdition;
                        if ($scope.ad.adminEdition)
                            $scope.ad.adminPanel = false;//force true
                        $scope.toggleMenu();
                    };

                    $scope.toggleMenu = function () {
                        $scope.ad.adminPanel = !$scope.ad.adminPanel && $scope.ad.adminEdition;
                        if ($scope.ad.adminPanel)
                            $spMenu.show();
                        else
                            $spMenu.hide();
                        $timeout(function () {
                            window.dispatchEvent(new Event('resize'));
                        }, 500);
                    };

                    $scope.onStartUploadImage = function () {
                        $scope.ad.view.imageUploadRunning = true;
                    };
                    $scope.onUploadImageSuccess = function (message) {
                        $scope.ad.view.imageUploadRunning = false;
                        try {
                            var companyImage = JSON.parse(message);
                            if (companyImage && companyImage.urlPreview) {
                                $scope.ad.view.logoImageUrl = companyImage.urlPreview;
                                $scope.ad.appAttributes.logoImageId = companyImage.id;
                            }
                        } catch (e) {
                            console.log('onUploadImageSuccess => JSON.parse error' , e);
                        }
                    };

                    $scope.onUploadGiftItemsImageSuccess = function (message) {
                        $scope.ad.view.imageUploadRunning = false;
                        try {
                            var companyImage = JSON.parse(message);
                            if (companyImage) {
                                $scope.ad.view.imagesCompanyView.unshift(companyImage);
                            }
                        } catch (e) {
                            console.log('onUploadGiftItemsImageSuccess => JSON.parse error' , e);
                        }
                    };

                    $scope.onUploadImageBgSuccess = function (message) {
                        $scope.ad.view.imageUploadRunning = false;
                        try {
                            var companyImage = JSON.parse(message);
                            if (companyImage) {
                                $scope.ad.view.imagesBgCompanyView.push(companyImage);
                            }
                        } catch (e) {
                            console.log('onUploadImageBgSuccess => JSON.parse error' , e);
                        }
                    };

                    $scope.onUploadImageAboutSuccess = function (message) {
                        $scope.ad.view.imageUploadRunning = false;
                        try {
                            var companyImage = JSON.parse(message);
                            if (companyImage) {
                                $scope.ad.view.imagesAboutCompanyView.push(companyImage);
                            }
                        } catch (e) {
                            console.log('onUploadImageAboutSuccess => JSON.parse error' , e);
                        }
                    };

                    $scope.removeImageAboutCompanyView = function (companyImage) {
                        var index = $scope.ad.view.imagesAboutCompanyView.indexOf(companyImage);
                        if (index != -1) {
                            $scope.ad.view.imagesAboutCompanyView.splice(index, 1);
                            CompanyImageSrv.remove(companyImage);
                        }
                    };

                    $scope.removeImageBgCompanyView = function (companyImage) {
                        var index = $scope.ad.view.imagesBgCompanyView.indexOf(companyImage);
                        if (index != -1) {
                            $scope.ad.view.imagesBgCompanyView.splice(index, 1);
                            CompanyImageSrv.remove(companyImage);
                        }
                    };

                    $scope.imageIsSelectedForGift = function (image) {
                        if ($scope.ad.view.imagesGiftView)
                            return ($scope.ad.view.imagesGiftView.indexOf(image) != -1)

                        return false;
                    };

                    $scope.toggleGiftImage = function (image) {
                        var index = $scope.ad.view.imagesGiftView.indexOf(image);
                        if (index === -1) {
                            $scope.ad.view.imagesGiftView.push(image)
                        }
                        else {
                            $scope.ad.view.imagesGiftView.splice(index, 1);
                        }
                    };


                    $scope.onImageBgUpdate = function () {
                        if ($scope.ad.appAttributes.globalBgImageUseSlide) {
                            $scope.ad.appAttributes.globalBgImage = null;
                            $scope.ad.appAttributes.globalBgColor = null;
                        }

                    };

                    $scope.adjustModalPosition = function () {
                        $timeout(function () {
                            var elm = $(".modal");
                            if (elm && elm[0]) {
                                var height = $(window).height();
                                var scrollTop = $(window).scrollTop();
                                elm.animate({ top: scrollTop + 50, height: height - 100 });

                            }
                            else
                                $timeout(function () {
                                    var elm = $(".modal");
                                    if (elm && elm[0]) {
                                        var height = $(window).height();
                                        var scrollTop = $(window).scrollTop();
                                        elm.animate({ top: scrollTop + 50, height: height - 100 });

                                    }
                                    else
                                        $timeout(function () {
                                            var elm = $(".modal");
                                            if (elm && elm[0]) {
                                                var height = $(window).height();
                                                var scrollTop = $(window).scrollTop();
                                                elm.animate({ top: scrollTop + 50, height: height - 100 });

                                            }
                                        }, 1000
                                        );
                                }, 500
                                );
                        }, 200
                        );
                    };

                    $scope.editCategoryView = function (categoryView) {
                        var opts = {
                            backdrop: true,
                            keyboard: true,
                            backdropClick: false,
                            templateUrl: '/partials-web/editor/categoryEditor.html',
                            controller: 'WebSiteEditorCtrl',
                            resolve: {
                                dialogsModel: function () {
                                    var tableModel = [];
                                    tableModel["categoryView"] = categoryView;
                                    tableModel["ad"] = $scope.ad;
                                    return tableModel;
                                }
                            }
                        };

                        var d = $dialog.dialog(opts);
                        d.open().then(function (result) {
                            if (result) {

                            }
                        });
                        $scope.adjustModalPosition();

                    };
                    $scope.editServiceView = function (serviceView) {
                        var opts = {
                            backdrop: true,
                            keyboard: true,
                            backdropClick: false,
                            templateUrl: '/partials-web/editor/serviceEditor.html',
                            controller: 'WebSiteEditorCtrl',
                            resolve: {
                                dialogsModel: function () {
                                    var tableModel = [];
                                    tableModel["serviceView"] = serviceView;
                                    tableModel["ad"] = $scope.ad;
                                    return tableModel;
                                }
                            }
                        };

                        var d = $dialog.dialog(opts);
                        d.open().then(function (result) {
                            if (result) {

                            }
                        });
                        $scope.adjustModalPosition();

                    };

                    $scope.editProductView = function (productView) {
                        var opts = {
                            backdrop: true,
                            keyboard: true,
                            backdropClick: false,
                            templateUrl: '/partials-web/editor/productEditor.html',
                            controller: 'WebSiteEditorCtrl',
                            resolve: {
                                dialogsModel: function () {
                                    var tableModel = [];
                                    tableModel["productView"] = productView;
                                    tableModel["ad"] = $scope.ad;
                                    return tableModel;
                                }
                            }
                        };

                        var d = $dialog.dialog(opts);
                        d.open().then(function (result) {
                            if (result) {

                            }
                        });
                        $scope.adjustModalPosition();
                    };
                    $scope.editCureView = function (cureView) {
                        var opts = {
                            backdrop: true,
                            keyboard: true,
                            backdropClick: false,
                            templateUrl: '/partials-web/editor/cureEditor.html',
                            controller: 'WebSiteEditorCtrl',
                            resolve: {
                                dialogsModel: function () {
                                    var tableModel = [];
                                    tableModel["cureView"] = cureView;
                                    tableModel["ad"] = $scope.ad;
                                    return tableModel;
                                }
                            }
                        };

                        var d = $dialog.dialog(opts);
                        d.open().then(function (result) {
                            if (result) {

                            }
                        });
                        $scope.adjustModalPosition();

                    };

                    $scope.editHomeItemsView = function () {
                        var opts = {
                            backdrop: true,
                            keyboard: true,
                            backdropClick: false,
                            templateUrl: '/partials-web/editor/offerEditor.html',
                            controller: 'WebSiteEditorCtrl',
                            resolve: {
                                dialogsModel: function () {
                                    var tableModel = [];
                                    tableModel["ad"] = $scope.ad;
                                    return tableModel;
                                }
                            }
                        };

                        var d = $dialog.dialog(opts);
                        d.open().then(function (result) {
                            if (result) {

                            }
                        });
                        $scope.adjustModalPosition();

                    };
                    $scope.addWidget = function (array, first) {
                        if (array) {
                            var newWidgetView = new WidgetView(null, array.length, false, $scope);

                            $scope.editWidgetView(newWidgetView, function () {
                                if (first) {
                                    for (var i = 0; i < array.length; i++)
                                        array[i].y += newWidgetView.height;
                                    array.push(newWidgetView);
                                    $timeout(function () {
                                        window.dispatchEvent(new Event('resize'));
                                    }, 500);

                                }
                                else {
                                    if (array.length) {
                                        var maxY = array[0].y + array[0].height;
                                        for (var i = 1; i < array.length; i++)
                                            if ((array[i].y + array[i].height) > maxY)
                                                maxY = (array[i].y + array[i].height);
                                        newWidgetView.y = maxY;
                                    }
                                    array.push(newWidgetView);

                                }

                            });
                        }
                    };

                    $scope.createAndEditImgWidgetView = function (object) {
                        if (object) {
                            var widgetView = object.createImgWidgetView();
                            if (widgetView)
                                $scope.editWidgetView(widgetView);
                        }
                    }
                    $scope.createAndEditSubWidgetView = function (object) {
                        if (object) {
                            var widgetView = object.createSubWidgetView();
                            if (widgetView) {
                                if (object.subWidgetsView && object.subWidgetsView.length > 0)
                                    widgetView.y = object.subWidgetsView[object.subWidgetsView.length - 1].y + object.subWidgetsView[object.subWidgetsView.length - 1].height + 1;
                                $scope.editWidgetView(widgetView);
                            }
                        }
                    }
                    $scope.editWidgetView = function (widgetView, endFunction) {
                        if (widgetView) {
                            var opts = {
                                backdrop: true,
                                keyboard: true,
                                backdropClick: false,
                                templateUrl: widgetView.isDefault ? '/partials-web/editor/defaultWidgetEditor.html' : '/partials-web/editor/widgetEditor.html',
                                controller: 'WebSiteEditorCtrl',
                                resolve: {
                                    dialogsModel: function () {
                                        var tableModel = [];
                                        tableModel["widgetView"] = widgetView;
                                        tableModel["ad"] = $scope.ad;
                                        tableModel["parentScope"] = $scope
                                        return tableModel;
                                    }
                                }
                            };

                            var d = $dialog.dialog(opts);
                            d.open().then(function (result) {
                                if (result) {
                                    if (endFunction !== undefined)
                                        endFunction();
                                }
                            });
                            $scope.adjustModalPosition();
                        }
                    };
                    $scope.changeOrder = function (categoryView) {
                        var opts = {
                            backdrop: true,
                            keyboard: true,
                            backdropClick: false,
                            templateUrl: '/partials-web/editor/categoryOrder.html',
                            controller: 'WebSiteEditorCtrl',
                            resolve: {
                                dialogsModel: function () {
                                    var tableModel = [];
                                    tableModel["categoryView"] = categoryView;
                                    tableModel["ad"] = $scope.ad;
                                    return tableModel;
                                }
                            }
                        };

                        var d = $dialog.dialog(opts);
                        d.open().then(function (result) {
                            if (result) {

                            }
                        });
                        $scope.adjustModalPosition();

                    };

                    $scope.editGiftItemImage = function (giftItemType) {
                        $scope.ad.view.giftItemTypeSelected = giftItemType;
                        manageSubTabAndImageSelected(giftItemType);
                        initDialogWebSiteEditorCtrl();
                    }

                    function manageSubTabAndImageSelected(giftItemType) {
                        let imageIndex = findImageIndexByType($scope.ad.view.imagesServiceView, giftItemType);
                        let image = (imageIndex !== -1) ? $scope.ad.view.imagesServiceView[imageIndex] : null;
                        if (image) {
                            $scope.selectGiftItemImage(image);
                            $scope.ad.view.dialogWebSiteEditorCtrl.subTab = 1;
                            $scope.ad.view.imagesServiceView.splice(0, 0, $scope.ad.view.imagesServiceView.splice(imageIndex, 1)[0]);
                        } else {
                            imageIndex = findImageIndexByType($scope.ad.view.imagesCompanyView, giftItemType);
                            let image = (imageIndex !== -1) ? $scope.ad.view.imagesCompanyView[imageIndex] : null;
                            if (image) {
                                $scope.selectGiftItemImage(image);
                                $scope.ad.view.dialogWebSiteEditorCtrl.subTab = 2;
                                $scope.ad.view.imagesCompanyView.splice(0, 0, $scope.ad.view.imagesCompanyView.splice(imageIndex, 1)[0]);
                            } else {
                                if ($scope.ad.view.currentGiftItemImage) {
                                    $scope.ad.view.currentGiftItemImage.isSelected = false;
                                }
                                $scope.ad.view.dialogWebSiteEditorCtrl.subTab = 1;
                            }
                        }
                    }

                    function initDialogWebSiteEditorCtrl() {
                        var opts = {
                            backdrop: true,
                            keyboard: true,
                            backdropClick: false,
                            templateUrl: '/partials-web/editor/giftItemEditor.html',
                            controller: 'WebSiteEditorCtrl',
                            resolve: {
                                dialogsModel: function () {
                                    var tableModel = [];
                                    tableModel["ad"] = $scope.ad;
                                    return tableModel;
                                }
                            }
                        };

                        var d = $dialog.dialog(opts);
                        d.open().then( (result) => {

                        });
                        $scope.adjustModalPosition();
                    }

                    function findImageIndexByType(imagesView, giftItemType) {
                        switch (giftItemType) {
                            case "mail":
                                return imagesView.findIndex( (element) =>
                                    element.id == $scope.ad.appAttributes.giftItemMailImageId);
                            case "delivery":
                                return imagesView.findIndex( (element) =>
                                    element.id == $scope.ad.appAttributes.giftItemDeliveryImageId);
                            case "printable":
                                return imagesView.findIndex( (element) =>
                                    element.id == $scope.ad.appAttributes.giftItemPrintableImageId);
                            default:
                                break;
                        }
                    }

                    $scope.selectGiftItemImage = function (image) {
                        image.isSelected = true;
                        if ($scope.ad.view.currentGiftItemImage !== image) {
                            if ($scope.ad.view.currentGiftItemImage) {
                                $scope.ad.view.currentGiftItemImage.isSelected = false;
                            }
                            $scope.ad.view.currentGiftItemImage = image;
                        }
                    }
                }
            }
        }
    ]);




// WEBPACK FOOTER //
// ./js/controllers/customerSite/WebSiteCtrl.js